export default {
  "nav": {
    "feed": "Feed",
    "map": "Karte",
    "discover": "Vibes",
    "plans": "Pläne",
    "messages": "Chat",
    "profile": "Profil"
  },
  "common": {
    "back": "Zurück",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "saving": "Speichern...",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "remove": "Entfernen",
    "refresh": "Aktualisieren",
    "error": "Fehler",
    "loading": "Laden...",
    "tryAgain": "Bitte versuche es erneut.",
    "clear": "Zurücksetzen",
    "enable": "Aktivieren",
    "tapToRetry": "Zum Wiederholen tippen",
    "somethingWentWrong": "Etwas ist schiefgelaufen.",
    "comingSoon": "BALD VERFÜGBAR",
    "send": "Senden",
    "ok": "OK",
    "gotIt": "Verstanden",
    "couldNotOpenLink": "Link konnte nicht geöffnet werden.",
    "done": "Fertig",
    "retry": "Erneut versuchen",
    "later": "Später",
    "notNow": "Nicht jetzt",
    "openSettings": "Einstellungen öffnen",
    "loadingTonyte": "Laden Tonyte…",
    "findingYourVibe": "Finde deinen Vibe…",
    "almostThere": "Fast geschafft…",
    "stillGettingThingsReady": "Wir bereiten noch alles vor…",
    "profileLoadErrorTitle": "Profil konnte nicht geladen werden",
    "profileLoadErrorMessage": "Überprüfe deine Verbindung und versuche es erneut.",
    "continue": "Weiter",
    "unknown": "Unbekannt",
    "unknownError": "Unbekannter Fehler.",
    "user": "Benutzer",
    "sharedOnTonyte": "{name} auf Tonyte"
  },
  "auth": {
    "signInRequired": "Anmeldung erforderlich",
    "signInToUseFeature": "Melde dich an, um diese Funktion zu nutzen.",
    "emailAlreadyInUse": "Es existiert bereits ein Konto mit dieser E-Mail. Melden Sie sich stattdessen an.",
    "invalidEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "invalidCredentials": "Die E-Mail-Adresse oder das Passwort ist falsch.",
    "weakPassword": "Verwenden Sie ein Passwort mit mindestens 6 Zeichen.",
    "methodNotEnabled": "Diese Anmeldemethode ist noch nicht aktiviert.",
    "networkError": "Netzwerkfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "signInFailed": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "notSignedIn": "Nicht angemeldet.",
    "googleSignInUnavailable": "Google Sign-In ist in diesem Build nicht verfügbar. Erstellen Sie die App neu, nachdem Sie die nativen Abhängigkeiten installiert haben.",
    "googleSignInCancelled": "Die Google-Anmeldung wurde abgebrochen.",
    "googleMissingIdToken": "Bei der Google-Anmeldung wurde kein ID-Token zurückgegeben.",
    "appleSignInUnavailable": "Die Apple-Anmeldung ist auf diesem Gerät nicht verfügbar.",
    "appleMissingIdentityToken": "Bei der Apple-Anmeldung wurde kein Identitätstoken zurückgegeben.",
    "appleSignInCancelled": "Die Apple-Anmeldung wurde abgebrochen."
  },
  "verifyEmail": {
    "title": "Bestätige deine E-Mail-Adresse",
    "subtitle": "Wir haben einen Bestätigungslink gesendet an",
    "instructions": "Tippe auf den Link in dieser E-Mail und kehre dann hierher zurück, um auf \"Erneut prüfen\" zu tippen.",
    "resend": "Bestätigungs-E-Mail erneut senden",
    "resendCooldown": "Erneut senden in {count}s",
    "resendSuccess": "Bestätigungs-E-Mail gesendet.",
    "resendFailure": "Die Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuche es erneut.",
    "resendRateLimited": "Bitte warte einen Moment, bevor du eine weitere E-Mail anforderst.",
    "checkAgain": "Erneut prüfen",
    "checking": "Wird geprüft…",
    "stillNotVerified": "Noch nicht bestätigt",
    "stillNotVerifiedMessage": "Wir können für dieses Konto noch keine bestätigte E-Mail-Adresse finden. Prüfe deinen Posteingang (und den Spam-Ordner) und versuche es erneut.",
    "verifiedSuccess": "E-Mail bestätigt! Du hast jetzt vollen Zugriff.",
    "continueBrowsing": "Weiter zu Events & Karte",
    "logout": "Abmelden / Konto wechseln",
    "limitedAccessBanner": "Bestätige deine E-Mail, um Vibe, Pläne, Chat u. v. m. freizuschalten.",
    "limitedAccessBannerAction": "Jetzt bestätigen",
    "gateTitle": "Bestätige zuerst deine E-Mail",
    "gateMessage": "Diese Funktion wird freigeschaltet, sobald du deine E-Mail-Adresse bestätigt hast.",
    "gateAction": "Jetzt bestätigen"
  },
  "resetPassword": {
    "title": "Passwort zurücksetzen",
    "subtitle": "Wähle ein neues Passwort für dein Tonyte-Konto.",
    "expiredLink": "Dieser Link zum Zurücksetzen ist abgelaufen. Fordere bei Tonyte einen neuen an.",
    "invalidLink": "Dieser Link ist ungültig oder wurde bereits verwendet.",
    "weakPassword": "Verwende ein Passwort mit mindestens 6 Zeichen.",
    "networkError": "Netzwerkfehler. Prüfe deine Verbindung und versuche es erneut.",
    "verifyFailed": "Wir konnten diesen Link nicht prüfen. Fordere bitte einen neuen an.",
    "missingCode": "In diesem Link fehlt der Bestätigungscode.",
    "mismatch": "Die Passwörter stimmen nicht überein.",
    "verifying": "Link wird überprüft...",
    "updating": "Passwort wird aktualisiert...",
    "success": "Passwort erfolgreich aktualisiert",
    "continueToLogin": "Weiter zur Anmeldung",
    "unavailable": "Link nicht verfügbar",
    "resettingFor": "Passwort zurücksetzen für {email}",
    "newPassword": "Neues Passwort",
    "minimumCharacters": "Mindestens 6 Zeichen",
    "confirmPassword": "Passwort bestätigen",
    "enterAgain": "Passwort erneut eingeben",
    "updatePassword": "Passwort aktualisieren"
  },
  "vibesList": {
    "eyebrow": "DEINE LEUTE",
    "title": "Vibes",
    "search": "Deine Vibes durchsuchen",
    "noMatches": "Keine passenden Vibes",
    "noMatchesSub": "Suche nach Name, Benutzername, Stadt oder Universität.",
    "empty": "Noch keine Vibes",
    "emptySub": "Menschen, mit denen du dich über Chats und Vibes verbindest, erscheinen hier.",
    "openDailyVibes": "Zu Daily Vibes",
    "removeTitle": "Diesen Vibe entfernen?",
    "removeBody": "Die Person wird aus deinen Vibes entfernt. Der bestehende Chatverlauf bleibt erhalten.",
    "removeFailed": "Dieser Vibe konnte gerade nicht entfernt werden.",
    "message": "Nachricht",
    "viewProfile": "Profil ansehen",
    "community": "Tonyte-Community",
    "recentlyActive": "Kürzlich aktiv",
    "activeMinutes": "Vor {count} Min. aktiv",
    "activeHours": "Vor {count} Std. aktiv",
    "activeDays": "Vor {count} T. aktiv",
    "removeAccessibility": "{name} aus Vibes entfernen",
    "removeSuccess": "{name} wurde aus deinen Vibes entfernt"
  },
  "partner": {
    "profileSelectorTitle": "Partnerprofil auswählen",
    "profileSelectorBody": "Dieses Konto verwaltet mehr als einen Partner.",
    "profileUnavailableTitle": "Partnerprofil nicht verfügbar",
    "profileLoadFailed": "Wir konnten deinen Partnerzugang nicht prüfen. Versuche es erneut – deine Kontodaten bleiben erhalten.",
    "profileLinkMissing": "Dein Partnerkonto ist aktiv, aber mit keinem Partnerprofil verknüpft. Wende dich an den Tonyte-Support, um den Zugang wiederherzustellen.",
    "publicProfileUnavailableBody": "Dieses Partnerprofil ist gerade nicht verfügbar.",
    "publicProfileLoadFailed": "Dieses Profil konnte nicht geladen werden. Prüfe deine Verbindung und versuche es erneut.",
    "kicker": "Tonyte Partner",
    "tools": "Partner-Tools",
    "profile": "Partnerprofil",
    "profileSub": "Verwalte, wie dein Unternehmen auf Tonyte erscheint",
    "createEvent": "Event erstellen",
    "createEventSub": "Ein neues Event veröffentlichen",
    "myEvents": "Meine Events",
    "myEventsSub": "Bevorstehende und laufende Events ansehen, bearbeiten oder löschen",
    "analytics": "Analytics",
    "analyticsSub": "Aufrufe, Interessen und geteilte Inhalte",
    "notifications": "Benachrichtigungen",
    "notificationsSub": "Meilensteine und Neuigkeiten zu deinen Events",
    "noNotifications": "Noch keine Benachrichtigungen.",
    "totalTaps": "Aufrufe gesamt",
    "interestedTaps": "Interessen",
    "shares": "Geteilt",
    "byEvent": "Nach Event",
    "noAnalytics": "Noch keine Events — veröffentliche dein erstes Event, um hier Analytics zu sehen.",
    "untitledEvent": "Event ohne Titel",
    "taps": "Aufrufe",
    "interested": "interessiert",
    "sharesLower": "geteilt",
    "createPassword": "Passwort erstellen",
    "firstSignIn": "Dies ist deine erste Anmeldung — lege ein neues Passwort fest.",
    "setPasswordContinue": "Passwort festlegen & weiter",
    "setPasswordFailed": "Passwort konnte nicht festgelegt werden. Versuche es erneut.",
    "signOut": "Abmelden",
    "notAssigned": "Noch nicht zugewiesen",
    "categoryMissing": "Ihre Partnerkategorie wurde noch nicht zugewiesen. Wenden Sie sich an den Tonyte-Administrator, um Ihre Kontokategorie einzurichten.",
    "typeCommunity": "Gemeinschaft",
    "typeOrganizer": "Organisator",
    "typeVenue": "Veranstaltungsort",
    "typeUniversity": "Universität",
    "typeStudentOrganization": "Studentenorganisation",
    "businessName": "Firmenname",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Sagen Sie den Leuten, worum es Ihnen geht",
    "website": "Website",
    "instagram": "Instagram",
    "venueAddress": "Adresse des Veranstaltungsortes",
    "venueAddressPlaceholder": "Straße, Stadt, Land",
    "saveChanges": "Änderungen speichern",
    "viewTerms": "Partnerbedingungen anzeigen",
    "requiredFields": "Firmenname und Beschreibung sind erforderlich.",
    "venueAddressRequired": "Eine Adresse des Veranstaltungsortes ist erforderlich.",
    "profileUpdated": "Profil aktualisiert.",
    "profileSaveFailed": "Ihr Profil konnte nicht gespeichert werden. Bitte versuchen Sie es erneut."
  },
  "editProfile": {
    "nameRequired": "Name erforderlich",
    "addName": "Füge vor dem Speichern einen Namen hinzu.",
    "invalidDob": "Ungültiges Geburtsdatum",
    "ageRequirement": "Tonyte ist für Reisende ab {age} Jahren. Prüfe bitte dein Geburtsdatum.",
    "saveFailed": "Profil konnte nicht gespeichert werden",
    "name": "Name *",
    "yourName": "Dein Name",
    "bio": "Bio",
    "bioPlaceholder": "Erzähl der Community etwas über dich…",
    "city": "Stadt",
    "yourCity": "Deine Stadt",
    "country": "Land",
    "yourCountry": "Dein Land",
    "dateOfBirth": "Geburtsdatum",
    "personality": "Persönlichkeit",
    "selectedCount": "{count}/30 ausgewählt",
    "addCustom": "„{interest}“ hinzufügen"
  },
  "waitingList": {
    "title": "Du bist auf der Warteliste",
    "badge": "EARLY ACCESS",
    "headline": "Hör auf zu scrollen.\nGeh raus.",
    "supportingText": "Wir laden schrittweise neue Mitglieder ein, damit die Community authentisch, aktiv und sicher bleibt.",
    "featureEventsTitle": "Events finden",
    "featureEventsBody": "Entdecke, was in deiner Nähe passiert.",
    "featurePlansTitle": "Pläne erstellen",
    "featurePlansBody": "Starte einen Plan und finde Leute, die mitmachen.",
    "featureVibeTitle": "Täglicher Vibe",
    "featureVibeBody": "Beantworte ein paar Fragen und entdecke deine Vibe-Matches.",
    "featureTogetherTitle": "Nie mehr allein",
    "featureTogetherBody": "Finde immer etwas zu tun und jemanden, der dabei ist.",
    "applicationReceived": "Anmeldung erhalten",
    "notificationText": "Wir benachrichtigen dich, sobald dein Konto freigeschaltet ist.",
    "currentCity": "Aktuelle Stadt",
    "footer": "Danke, dass du uns hilfst, die Zukunft sozialer Entdeckungen aufzubauen.",
    "visitWebsite": "Webseite besuchen",
    "visitWebsiteSub": "So funktioniert Tonyte →"
  },
  "login": {
    "missingDetails": "Angaben fehlen",
    "enterEmailPassword": "Gib deine E-Mail-Adresse und dein Passwort ein.",
    "passwordTooShort": "Passwort zu kurz",
    "passwordMin": "Verwende mindestens 6 Zeichen.",
    "emailSignInFailed": "E-Mail-Authentifizierung fehlgeschlagen",
    "emailRequired": "E-Mail-Adresse erforderlich",
    "enterResetEmail": "Gib deine E-Mail-Adresse ein, um dein Passwort zurückzusetzen.",
    "forgotPassword": "Passwort vergessen?",
    "resetEmailSent": "E-Mail zum Zurücksetzen gesendet",
    "resetEmailSentMessage": "Prüfe deinen Posteingang auf den Link zum Zurücksetzen deines Passworts.",
    "passwordResetFailed": "Passwort konnte nicht zurückgesetzt werden",
    "signInFailed": "Anmeldung fehlgeschlagen",
    "appleSignInFailed": "Apple-Anmeldung fehlgeschlagen",
    "signInWithEmail": "Mit E-Mail anmelden",
    "createYourAccount": "Konto erstellen",
    "signIn": "Anmelden",
    "create": "Registrieren",
    "createAccount": "Konto erstellen",
    "email": "E-Mail",
    "password": "Passwort",
    "findYour": "Finde deine",
    "people": "Leute",
    "plans": "Pläne",
    "tagline": "Hör auf zu scrollen.\nGeh raus.",
    "featurePeople": "Finde deine Leute",
    "featureEvents": "Sieh, was läuft",
    "featureAlone": "Geh nie allein aus",
    "continueWithEmail": "Mit E-Mail fortfahren",
    "continueWithGoogle": "Mit Google fortfahren",
    "continueWithApple": "Mit Apple fortfahren",
    "legalPrefix": "Wenn du fortfährst, akzeptierst du unsere",
    "and": "und",
    "partnerSignInHint": "Tonyte Partner? Melde dich oben mit deiner Partner-ID oder E-Mail-Adresse an"
  },
  "settings": {
    "title": "Einstellungen",
    "account": "Konto",
    "appearance": "Darstellung",
    "midnight": "Midnight",
    "daylight": "Daylight",
    "language": "Sprache",
    "appLanguage": "App-Sprache",
    "languageSaved": "Sprache gespeichert",
    "languageSaveError": "Sprache konnte nicht gespeichert werden.",
    "profileManagement": "Profilverwaltung",
    "profileCompleted": "Profil vollständig",
    "profileCompletedSub": "Deine Profilantworten sind vollständig.",
    "editProfile": "Profil bearbeiten",
    "editProfileAnswers": "Profilantworten bearbeiten",
    "completeProfile": "Profil vervollständigen",
    "notifications": "Benachrichtigungen",
    "pushNotifications": "Push-Benachrichtigungen",
    "legal": "Rechtliches",
    "privacyPolicy": "Datenschutzerklärung",
    "termsOfService": "Nutzungsbedingungen",
    "communityGuidelines": "Community-Richtlinien",
    "impressum": "Impressum",
    "partnerTerms": "Partner-Bedingungen",
    "dataDeletionRequest": "Datenlöschung anfragen",
    "about": "Über",
    "tagline": "Menschen treffen. Die Nacht erleben.",
    "accountPrivacy": "Konto & Privatsphäre",
    "blockedAccounts": "Blockierte Konten",
    "faq": "FAQ",
    "helpFeedback": "Hilfe & Feedback",
    "verificationCenter": "Verifizierungscenter",
    "savedTemplates": "Gespeicherte Vorlagen",
    "uploadedPlans": "Hochgeladene Pläne",
    "adminControls": "Admin-Steuerung",
    "dataDeletion": "Datenlöschung",
    "logout": "Abmelden",
    "deleteAccount": "Konto löschen",
    "studentVerification": "Studierendenverifizierung",
    "vibeVerification": "Vibe-Verifizierung",
    "tonyteSettings": "Tonyte-Einstellungen",
    "version": "Version {version}",
    "search": "Sucheinstellungen",
    "clearSearch": "Einstellungssuche löschen",
    "profile": "Profil",
    "partnerDashboard": "Partner-Dashboard",
    "preferences": "Einstellungen",
    "privacyLegal": "Datenschutz und Recht",
    "support": "Unterstützung",
    "session": "Sitzung",
    "noSettings": "Keine Einstellungen gefunden",
    "noSettingsSub": "Versuchen Sie es mit einem anderen Schlüsselwort.",
    "connectedEmail": "Verbundene E-Mail",
    "noEmail": "Keine E-Mail verbunden",
    "signInMethod": "Anmeldemethode",
    "noSignInMethod": "Keine Anmeldemethode gefunden.",
    "passwordLogin": "Passwortanmeldung aktiviert",
    "connected": "{provider} verbunden",
    "sendReset": "Passwort-Reset senden",
    "sending": "Senden...",
    "unblock": "Entsperren",
    "noBlocked": "Keine gesperrten Konten.",
    "searchFaq": "Häufig gestellte Fragen durchsuchen",
    "feedbackPlaceholder": "Sagen Sie uns, was Ihnen durch den Kopf geht...",
    "feedbackEmail": "Kontakt-E-Mail (optional)",
    "sendFeedback": "Feedback senden",
    "chatNotifications": "Nachrichten & Vibes",
    "eventNotifications": "Pläne",
    "eventRecommendationNotifications": "Events & Empfehlungen",
    "partnerNotifications": "Partner, denen ich folge",
    "verifiedStudent": "Verifizierter Student",
    "verifiedStudentSub": "Sie haben vollen Zugriff auf Veranstaltungen nur für Studierende. Ihre Studenten-E-Mail wird vertraulich behandelt.",
    "checkInbox": "Überprüfen Sie Ihren Posteingang",
    "verificationSentPrefix": "Wir haben einen Bestätigungslink an gesendet",
    "verificationSentSuffix": "Klicken Sie auf den Link in dieser E-Mail, um den Besitz zu bestätigen.",
    "linkExpiry": "Der Link läuft in 24 Stunden ab. Überprüfen Sie Ihren Spam-Ordner, wenn Sie ihn nicht sehen.",
    "wrongEmail": "Falsche E-Mail?",
    "differentUniversityEmail": "Geben Sie eine andere Universitäts-E-Mail-Adresse ein",
    "resendVerification": "Bestätigungs-E-Mail erneut senden",
    "pendingReview": "Überprüfung steht aus",
    "pendingReviewSub": "Ihr E-Mail-Inhaber wurde bestätigt. Ein Administrator wird Ihre Institution in Kürze überprüfen. Nach der Genehmigung erhalten Sie Zugriff.",
    "verificationFailed": "Überprüfung fehlgeschlagen",
    "studentFailedSub": "Ihre Verifizierung wurde nicht genehmigt. Bitte versuchen Sie es erneut mit einer gültigen Universitäts-E-Mail-Adresse.",
    "universityEmail": "E-Mail-Adresse der Universität/Studenten",
    "universityEmailHelp": "Geben Sie Ihre Universitäts-E-Mail-Adresse ein. Wir senden Ihnen einen Bestätigungslink. Bekannte Institutionen werden sofort zugelassen; andere werden innerhalb von 24 Stunden überprüft.",
    "sendVerification": "Bestätigungs-E-Mail senden",
    "vibeVerifiedTitle": "Vibe Verifiziert",
    "vibeVerifiedSub": "Ihr Profil hat das Abzeichen. Andere Nutzer sehen Vertrauen, nicht Ihr Selfie.",
    "privacy": "Datenschutz",
    "verificationPrivacy": "Ihr Verifizierungs-Selfie wird manuell überprüft und gelöscht, nachdem die Verifizierungsentscheidung abgeschlossen ist. Verifizierungsmedien werden nur für die manuelle Überprüfung verwendet – Tonyte verwendet keine Gesichtserkennung, biometrische Analyse oder automatisierte Verifizierung.",
    "verificationPending": "Verifizierung steht aus",
    "verificationPendingSub": "Ihr Selfie befindet sich in der Überprüfungswarteschlange. Nach der Genehmigung erhalten Sie das Vibe Verified-Abzeichen.",
    "submittingSelfie": "Senden Sie Ihr Selfie…",
    "pendingAdminSub": "Ihre Anfrage bleibt ausstehend, bis sie von einem Administrator überprüft wird.",
    "selfieFailedSub": "Nehmen Sie das Selfie noch einmal bei guter Beleuchtung auf, Ihr Gesicht ist sichtbar und die Geste ist im Bild.",
    "tryAgain": "Versuchen Sie es erneut",
    "reviewSelfie": "Überprüfen Sie Ihr Selfie",
    "reviewSelfieSub": "Stellen Sie vor dem Absenden sicher, dass Ihr Gesicht und Ihre Gestik klar sind.",
    "retake": "Wiederholen",
    "submitReview": "Zur Überprüfung einreichen",
    "getVerified": "Lassen Sie sich Vibe verifizieren",
    "getVerifiedSub": "Machen Sie ein kurzes Selfie, um zu zeigen, dass Sie eine echte Person sind, und bauen Sie Vertrauen zu anderen auf. Ihr Verifizierungs-Selfie wird manuell überprüft und nach Abschluss der Verifizierungsentscheidung gelöscht.",
    "examplePose": "Beispielpose",
    "matchPose": "Machen Sie ein Selfie, das zur obigen Pose passt.",
    "faceVisible": "Gesicht deutlich sichtbar",
    "gestureVisible": "Handbewegung sichtbar",
    "goodLighting": "Gute Beleuchtung",
    "noFilters": "Keine Filter oder Screenshots",
    "takeVerificationSelfie": "Verifizierungs-Selfie machen",
    "deleteAccountTitle": "Konto löschen",
    "deleteAccountConfirm": "Sind Sie sicher, dass Sie Ihr Tonyte-Konto dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteProfileInfo": "Ihr Profil wird nicht mehr sichtbar sein.",
    "deleteDataInfo": "Ihre privaten Chats, Matches, Blockierungen, Swipes und Kontodaten werden entfernt.",
    "deletePlansInfo": "Ihre Community-Pläne werden gelöscht. Öffentliche Veranstaltungen werden durch diese Aktion nicht gelöscht.",
    "confirmIdentity": "Bestätigen Sie, dass Sie es sind",
    "reauthenticate": "Bitte authentifizieren Sie sich aus Sicherheitsgründen erneut bei {provider}, bevor wir Ihr Konto löschen.",
    "enterPassword": "Geben Sie Ihr Passwort ein",
    "loadingUsers": "Benutzer werden geladen…",
    "totalUsers": "{count} Gesamtzahl der Benutzer",
    "searchUsers": "Benutzer suchen...",
    "noEmailAvailable": "Keine E-Mail verfügbar",
    "protectedAccount": "Geschütztes Konto",
    "revoking": "Widerrufen…",
    "revokeVerified": "Widerruf Vibe Verifiziert",
    "suspendAccountAction": "Sperren",
    "unsuspendAccountAction": "Entsperren",
    "suspending": "Wird aktualisiert…",
    "suspendAccountTitle": "Konto sperren",
    "unsuspendAccountTitle": "Konto entsperren",
    "suspendAccountConfirm": "Konto von {name} sperren? Die Person wird abgemeldet und kann sich erst nach Entsperrung wieder anmelden.",
    "unsuspendAccountConfirm": "Konto von {name} entsperren? Die Person kann sich wieder anmelden.",
    "suspendAccountSuccess": "{name} wurde gesperrt.",
    "unsuspendAccountSuccess": "{name} wurde entsperrt.",
    "suspendAccountFailed": "Konto konnte nicht gesperrt werden. Bitte erneut versuchen.",
    "unsuspendAccountFailed": "Konto konnte nicht entsperrt werden. Bitte erneut versuchen.",
    "cannotSuspendSelf": "Du kannst dein eigenes Konto nicht sperren.",
    "deleteAccountAction": "Konto löschen",
    "deletingAccount": "Wird gelöscht…",
    "deleteAccountTitle": "Konto löschen",
    "deleteAccountConfirm1": "{name} ({email}) endgültig löschen? Dies entfernt das Konto dauerhaft und kann nicht rückgängig gemacht werden.",
    "deleteAccountFinalTitle": "Bist du dir absolut sicher?",
    "deleteAccountFinalBody": "Dies löscht das Konto endgültig aus Firebase Authentication und Tonyte. Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteAccountFinalAction": "Endgültig löschen",
    "deleteAccountSuccess": "{name} wurde endgültig gelöscht.",
    "deleteAccountFailed": "Konto konnte nicht gelöscht werden. Bitte erneut versuchen.",
    "cannotDeleteSelf": "Du kannst dein eigenes Konto nicht löschen.",
    "cannotDeleteAdmin": "Admins können keine anderen Admin-Konten löschen.",
    "noUsers": "Keine Benutzer gefunden",
    "noPendingRequests": "Keine ausstehenden Anfragen",
    "requestedEmail": "E-Mail angefordert",
    "domain": "Domäne",
    "requested": "Angefordert",
    "emailOwnership": "E-Mail-Besitz",
    "confirmed": "Bestätigt",
    "notConfirmed": "Nicht bestätigt",
    "accept": "Akzeptieren",
    "noPendingFace": "Keine ausstehenden Gesichtsanfragen",
    "noAccountEmail": "Keine Konto-E-Mail",
    "shakaSelfie": "Shaka-Selfie",
    "posePassLabel": "Pose",
    "livenessPassLabel": "Liveness",
    "front": "Vorne",
    "left": "Links",
    "right": "Richtig",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "eventCity": "Ereignisstadt",
    "eventCityHelp": "Ändert Ihren Feed und Ihre Kartenstadt."
  },
  "chat": {
    "title": "Chat",
    "subtitle": "Chats, Vibe-Anfragen und gesendete Vibes",
    "chats": "Chats",
    "vibeRequests": "Vibe-Anfragen",
    "sentVibes": "Gesendete Vibes",
    "searchChats": "Chats suchen",
    "noMessages": "Noch keine Nachrichten",
    "noChatsFound": "Keine Chats gefunden",
    "noChatsYet": "Noch keine Chats",
    "tryDifferentKeyword": "Versuche einen anderen Namen oder Suchbegriff.",
    "chatsAppearHere": "Deine Chats erscheinen hier",
    "joinToStart": "Tritt einem Event bei oder sende einen Vibe, um zu chatten.",
    "signInToUseVibes": "Melde dich an, um Vibes zu nutzen",
    "signInSub": "Erstelle ein Konto, um Vibe-Anfragen und private Chats zu sehen.",
    "translateChat": "Chat übersetzen",
    "translatingChat": "Übersetzen...",
    "showOriginal": "Original anzeigen",
    "translationFailed": "Chat konnte nicht übersetzt werden.",
    "chatUnmuted": "Chat-Stummschaltung aufgehoben",
    "chatMuted": "Chat stummgeschaltet",
    "leftChat": "Du hast den Chat verlassen",
    "blockUserQuestion": "Nutzer blockieren?",
    "blockUserMessage": "Du siehst keine Nachrichten mehr von {name}. Blockieren ist einseitig und benachrichtigt die Person nicht.",
    "thisUser": "dieser Person",
    "block": "Blockieren",
    "userBlocked": "Nutzer blockiert",
    "couldNotBlockUser": "Nutzer konnte nicht blockiert werden",
    "deleteChatQuestion": "Chat löschen?",
    "deleteChatMessage": "Dieser Chat wird dauerhaft gelöscht und kann nicht wiederhergestellt werden.",
    "chatDeleted": "Chat gelöscht",
    "couldNotDeleteChat": "Chat konnte nicht gelöscht werden",
    "deletePlanMessage": "Dadurch werden der Plan und sein Chat für alle Teilnehmer dauerhaft gelöscht.",
    "vibePromptsReady": "Deine Vibe-Sync-Prompts sind bereit",
    "you": "Du",
    "traveler": "Tonyte-Mitglied",
    "tonyteEvent": "TONYTE EVENT",
    "openEvent": "Event öffnen",
    "directMessage": "Direktnachricht",
    "youBlockedUser": "Du hast diesen Nutzer blockiert",
    "unblockInSettings": "Heb die Blockierung in den Profileinstellungen auf, um diesen Chat wieder zu sehen.",
    "vibeEnded": "Dieser Vibe ist beendet",
    "vibeEndedBody": "Diese Verbindung und ihr Chatverlauf existieren nicht mehr. Sende eine neue Vibe-Anfrage, um wieder in Kontakt zu treten.",
    "eventChatEnded": "Dieses Event ist beendet",
    "planChatEnded": "Dieser Plan ist beendet",
    "removeFromPlan": "Aus dem Plan entfernen",
    "removeFromPlanQuestion": "{name} aus diesem Plan entfernen?",
    "removeFromPlanMessage": "Diese Person verliert den Zugriff auf den Plan-Chat und ist nicht mehr Teil des Plans.",
    "removedFromPlan": "Du wurdest aus diesem Plan entfernt.",
    "memberRemoved": "Mitglied entfernt",
    "couldNotRemoveMember": "Dieses Mitglied konnte nicht entfernt werden. Bitte versuche es erneut.",
    "typeMessage": "Nachricht schreiben...",
    "couldNotSendImage": "Bild konnte nicht gesendet werden.",
    "locationUnavailable": "Standort nicht verfügbar.",
    "couldNotSendLocation": "Standort konnte nicht gesendet werden.",
    "sharedLocationLabel": "Geteilter Standort",
    "viewOnMap": "Auf der Karte ansehen",
    "invalidSharedLocation": "Dieser Standort kann gerade nicht geöffnet werden.",
    "eventExpiredLabel": "ABGELAUFEN",
    "eventExpired": "Event abgelaufen",
    "eventExpiredToast": "Dieses Event ist nicht mehr verfügbar.",
    "microphoneNowEnabled": "Mikrofonzugriff aktiviert",
    "reply": "Antworten",
    "gifs": "GIFS",
    "gifSearchResults": "Suchergebnisse",
    "gifTrendingNow": "Gerade angesagt",
    "searchGiphy": "GIPHY durchsuchen",
    "recentlyUsed": "Zuletzt verwendet",
    "gifsLoadFailed": "GIFs konnten nicht geladen werden. Prüfe deine Verbindung und versuche es erneut.",
    "microphoneAccessNeeded": "Mikrofonzugriff erforderlich",
    "microphoneAccessMessage": "Tonyte benötigt Mikrofonzugriff, um Sprachnachrichten zu senden. Aktiviere ihn in den Einstellungen.",
    "recordingUnavailable": "Aufnahme nicht verfügbar",
    "recordingUnavailableMessage": "Die Sprachaufnahme konnte nicht gestartet werden. Bitte versuche es erneut.",
    "wantsToVibe": "Möchte vibe mit dir",
    "status": "Status: {status}",
    "accepted": "Akzeptiert",
    "passed": "Bestanden",
    "pending": "Ausstehend",
    "profileSource": "Tonyte-Profil",
    "sharedPlan": "Gemeinsamer Plan",
    "sharedEvent": "Geteiltes Ereignis",
    "noRequestMessage": "Noch keine Nachricht hinzugefügt.",
    "vibe": "Vibe",
    "pass": "Bestanden",
    "alreadyVibing": "Schon vibrierend",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "vibeVerified": "Vibe Verifiziert",
    "bio": "Bio",
    "interests": "Interessen",
    "requestMessage": "Nachricht anfordern",
    "viewProfile": "Profil anzeigen",
    "working": "Arbeitet...",
    "cancelRequest": "Anfrage abbrechen",
    "peopleHere": "LEUTE HIER",
    "connectTravelers": "Finde deine Leute",
    "loadingTravelers": "Personen werden geladen...",
    "tryAgain": "Versuchen Sie es erneut",
    "noTravelers": "Noch niemand sonst hier.",
    "noTravelersSub": "Öffnen Sie „Personen hier“ als Erster und Ihre Karte wird anderen angezeigt.",
    "vibing": "Schwingung",
    "sent": "Gesendet",
    "accept": "Akzeptieren",
    "sendVibe": "Senden Sie ein vibe",
    "sendVibeSub": "Fügen Sie eine kurze Notiz für {name} hinzu. Sie können es auch leer versenden.",
    "optionalMessage": "Optionale Nachricht...",
    "sending": "Senden...",
    "sendVibeAction": "Senden Sie Vibe",
    "planChat": "CHAT PLANEN",
    "eventChat": "EVENT-CHAT",
    "communityPlan": "Gemeinschaftsplan",
    "officialEvent": "Offizielle Veranstaltung",
    "vibingWith": "Vibing With",
    "groupCount": "{count} {people} in diesem {kind}-Chat",
    "person": "Person",
    "people": "Menschen",
    "plan": "Plan",
    "event": "Ereignis",
    "loadingMembers": "Mitglieder werden geladen...",
    "openProfiles": "Profile öffnen und vibes senden",
    "deleteChat": "Chat löschen",
    "leaveChat": "Chat verlassen",
    "adminCannotLeave": "Planadministratoren können den Chat nicht verlassen. Stattdessen diesen Plan löschen?",
    "noStay": "Nein, bleib",
    "yesDeletePlan": "Ja, Plan löschen",
    "leavePlanConfirm": "Diesen Plan-Chat verlassen? Sie können über die Planseite wieder beitreten.",
    "leaveEventConfirm": "Diesen Event-Chat verlassen?",
    "leaving": "Verlassen…",
    "leave": "Gehen",
    "safety": "SICHERHEIT",
    "reportPerson": "Bericht {name}",
    "chooseReason": "Wählen Sie zunächst einen Grund.",
    "reportFailed": "Bericht fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "optionalDetails": "Optionale Details…",
    "submitReport": "Bericht einreichen",
    "reportUser": "Benutzer melden",
    "blockUser": "Benutzer blockieren",
    "viewProfileTitle": "Profil anzeigen",
    "muteChat": "Chat stumm schalten",
    "unmuteChat": "Chat-Stummschaltung aufheben",
    "loadingRequests": "Anfragen werden geladen...",
    "noPendingRequests": "Keine ausstehenden vibe-Anfragen",
    "pendingRequestsSub": "Eingegangene Anfragen werden hier angezeigt, bevor sie in die Chats verschoben werden.",
    "loadingSent": "Gesendet wird geladen vibes...",
    "noSent": "Noch kein vibes gesendet",
    "noSentSub": "Vibes, die Sie von „People Here“ senden, wird hier verfolgt.",
    "reasonSpam": "Spam",
    "reasonHarassment": "Belästigung",
    "reasonFake": "Gefälschtes Profil",
    "reasonContent": "Unangemessener Inhalt",
    "reasonScam": "Betrug oder unsicheres Verhalten",
    "reasonOther": "Sonstiges",
    "tonyteVenue": "TONYTE LOCATION",
    "newMessage": "Neue Nachricht",
    "newMessageFallback": "Sie haben eine neue Nachricht erhalten.",
    "someone": "Jemand",
    "requestAcceptFailed": "Anfrage konnte nicht angenommen werden. Bitte versuchen Sie es erneut.",
    "requestDeclineFailed": "Anfrage konnte nicht abgelehnt werden. Bitte versuchen Sie es erneut.",
    "requestCancelFailed": "Die Anfrage konnte nicht abgebrochen werden. Bitte versuchen Sie es erneut.",
    "travelersLoadFailed": "Personen konnten nicht geladen werden. Bitte versuche es erneut.",
    "signInSendVibes": "Melden Sie sich an, um vibe-Anfragen zu senden.",
    "vibeRequestSendFailed": "vibe-Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "nowVibingWith": "Du schwingst jetzt mit {name}!",
    "leaveFailed": "Chat konnte nicht verlassen werden. Bitte versuchen Sie es erneut.",
    "requestPassed": "Anfrage bestanden",
    "gifSendFailed": "GIF konnte nicht gesendet werden. Versuchen Sie es erneut.",
    "voiceUploadFailed": "Das Hochladen der Sprachnotiz ist fehlgeschlagen. Tippen Sie in der Nachricht auf „Wiederholen“.",
    "reportSubmitted": "Bericht eingereicht",
    "now": "jetzt",
    "minutesShort": "{count}m",
    "hoursShort": "{count}h",
    "daysShort": "{count}d",
    "vibingCount_one": "{count} Person am Viben",
    "vibingCount_few": "{count} Leute am Viben",
    "vibingCount_many": "{count} Leute am Viben",
    "vibingCount_other": "{count} Leute am Viben",
    "memberJoined": "{name} ist dem Chat beigetreten",
    "memberLeft": "{name} hat den Chat verlassen",
    "lastSeenJustNow": "Gerade eben zuletzt gesehen",
    "lastSeenMinutes_one": "Zuletzt vor {count} Min. gesehen",
    "lastSeenMinutes_few": "Zuletzt vor {count} Min. gesehen",
    "lastSeenMinutes_many": "Zuletzt vor {count} Min. gesehen",
    "lastSeenMinutes_other": "Zuletzt vor {count} Min. gesehen",
    "lastSeenHours_one": "Zuletzt vor {count} Std. gesehen",
    "lastSeenHours_few": "Zuletzt vor {count} Std. gesehen",
    "lastSeenHours_many": "Zuletzt vor {count} Std. gesehen",
    "lastSeenHours_other": "Zuletzt vor {count} Std. gesehen",
    "lastSeenYesterday": "Zuletzt gesehen gestern",
    "lastSeenDays_one": "Zuletzt vor {count} T. gesehen",
    "lastSeenDays_few": "Zuletzt vor {count} T. gesehen",
    "lastSeenDays_many": "Zuletzt vor {count} T. gesehen",
    "lastSeenDays_other": "Zuletzt vor {count} T. gesehen",
    "lastSeenAWhileAgo": "Zuletzt vor einiger Zeit gesehen",
    "seen": "Gesehen",
    "seenJustNow": "Gerade erst gesehen",
    "seenMinutes_one": "Vor {count} Min. gesehen",
    "seenMinutes_few": "Vor {count} Min. gesehen",
    "seenMinutes_many": "Vor {count} Min. gesehen",
    "seenMinutes_other": "Vor {count} Min. gesehen",
    "seenHours_one": "Vor {count}h gesehen",
    "seenHours_few": "Vor {count}h gesehen",
    "seenHours_many": "Vor {count}h gesehen",
    "seenHours_other": "Vor {count}h gesehen",
    "yesterday": "Gestern",
    "typing": "Tippen...",
    "online": "Online",
    "studiZonePlan": "StudiZone-Plan"
  },
  "discover": {
    "heroTitle": "Vibes",
    "vibesSubtitle": "Menschen. Orte. Campus.",
    "findMyVibeTitle": "Finde meinen Vibe",
    "findMyVibeDesc": "Spiel das Quiz. Triff deine Leute.",
    "venuesCardDesc": "Partnerprofile.",
    "studiZoneCardDesc": "Campus-Community.",
    "statusOpensAt": "Ab {time}",
    "statusResultsAt": "Ergebnisse {time}",
    "statusResultsOut": "Ergebnisse da",
    "studiZoneVerifiedOnly": "Verifizierte Studis",
    "infoPill": "Beantworte ein paar Fragen. Finde deinen Vibe. Finde deine Leute.",
    "addPhotoLocked": "Füge ein echtes Profilfoto hinzu, bevor du Social Discovery nutzt.",
    "daySubtitle": "Mach den heutigen Vibe-Check",
    "dayDescription": "Beantworte ein paar tägliche Fragen, entdecke deine Aura und schalte deinen Vibe Circle frei, um Menschen auf deiner Wellenlänge zu finden.",
    "venueSubtitle": "Entdecke, wer deine Stadt prägt",
    "venueDescription": "Entdecke lokale Locations, Artists, Communities und Hosts. Folge deinen Favoriten und finde ihre Events, Updates und Kalender.",
    "studiZoneTitle": "StudiZone",
    "studiZoneSubtitle": "Dein verifizierter Studierendenbereich",
    "studiZoneDescription": "Entdecke Campus-Events, studentische Pläne, Communities und Chats für verifizierte Studierende.",
    "studiZoneButton": "StudiZone öffnen ->",
    "letsGo": "Los gehts ->",
    "citySync": "City Sync",
    "tonightSync": "Tonight Sync",
    "auraLockedText": "Neu hier? Kein Problem.\nDer heutige Aura-Scan öffnet um 6:00 Uhr.",
    "auraQuestionsText": "Beantworte die Fragen.\nFinde deine Aura und schalte deinen Vibe Circle frei.",
    "auraResultsText": "Ergebnisse sind da.\nFinde deine Aura und entdecke, mit wem du heute vibest.",
    "auraOpenTime": "6:00",
    "auraResultsTime": "13:00",
    "am": "UHR",
    "pm": "UHR",
    "live": "LIVE",
    "now": "JETZT",
    "underConstruction": "In Entwicklung",
    "venueTesterUnavailable": "Vibe in Locations wird für den Early Access vorbereitet. Aura Vibe bleibt verfügbar."
  },
  "feedFilters": {
    "now": "Jetzt",
    "tonight": "Heute Abend",
    "parties": "Partys",
    "social": "Social",
    "nearby": "In der Nähe",
    "high-energy": "Volle Energie",
    "food": "Essen",
    "activities": "Aktivitäten",
    "chill": "Entspannt",
    "date-idea": "Date-Idee",
    "solo-friendly": "Gut allein",
    "student": "Studierende",
    "free": "Kostenlos"
  },
  "interests": {
    "addInterests": "Interessen hinzufügen",
    "selectedInterests": "Ausgewählte Interessen",
    "selected": "ausgewählt",
    "searchInterests": "Interessen suchen",
    "add": "Hinzufügen",
    "saveInterests": "Interessen speichern",
    "categories": {
      "travel": "Reisen",
      "food_and_drinks": "Essen & Getränke",
      "nightlife": "Nachtleben",
      "sports_and_fitness": "Sport & Fitness",
      "music": "Musik",
      "art_and_creativity": "Kunst & Kreativität",
      "social_and_culture": "Soziales & Kultur",
      "tech_and_gaming": "Technik & Gaming",
      "outdoors": "Outdoor",
      "relax_and_lifestyle": "Entspannung & Lifestyle"
    },
    "items": {
      "backpacking": "Backpacking",
      "road_trips": "Roadtrips",
      "solo_travel": "Alleinreisen",
      "luxury_travel": "Luxusreisen",
      "digital_nomad": "Digitales Nomadentum",
      "adventure_travel": "Abenteuerreisen",
      "city_exploration": "Städte entdecken",
      "beach_trips": "Strandreisen",
      "mountains": "Berge",
      "camping": "Camping",
      "street_food": "Streetfood",
      "fine_dining": "Gehobene Küche",
      "cafes": "Cafés",
      "bars": "Bars",
      "cocktails": "Cocktails",
      "wine_tasting": "Weinverkostung",
      "beer": "Bier",
      "cooking": "Kochen",
      "vegan_food": "Veganes Essen",
      "desserts": "Desserts",
      "clubbing": "Clubbing",
      "house_music": "House-Musik",
      "techno": "Techno",
      "hip_hop": "Hip-Hop",
      "live_djs": "Live-DJs",
      "pub_crawls": "Kneipentouren",
      "after_parties": "Afterpartys",
      "festivals": "Festivals",
      "dance": "Tanzen",
      "karaoke": "Karaoke",
      "gym": "Fitnessstudio",
      "running": "Laufen",
      "football": "Fußball",
      "basketball": "Basketball",
      "yoga": "Yoga",
      "hiking": "Wandern",
      "cycling": "Radfahren",
      "swimming": "Schwimmen",
      "martial_arts": "Kampfsport",
      "crossfit": "CrossFit",
      "rap": "Rap",
      "pop": "Pop",
      "rock": "Rock",
      "edm": "EDM",
      "jazz": "Jazz",
      "classical": "Klassik",
      "indie": "Indie",
      "lo_fi": "Lo-Fi",
      "live_concerts": "Live-Konzerte",
      "singing": "Singen",
      "photography": "Fotografie",
      "painting": "Malerei",
      "graphic_design": "Grafikdesign",
      "illustration": "Illustration",
      "3d_art": "3D-Kunst",
      "videography": "Videografie",
      "content_creation": "Content-Erstellung",
      "fashion": "Mode",
      "tattoo_art": "Tattoo-Kunst",
      "animation": "Animation",
      "meeting_people": "Leute kennenlernen",
      "languages": "Sprachen",
      "cultural_exchange": "Kulturaustausch",
      "volunteering": "Ehrenamt",
      "networking": "Networking",
      "events": "Events",
      "public_speaking": "Öffentliches Sprechen",
      "debates": "Debatten",
      "history": "Geschichte",
      "museums": "Museen",
      "gaming": "Gaming",
      "pc_gaming": "PC-Gaming",
      "console_gaming": "Konsolen-Gaming",
      "ai": "KI",
      "startups": "Start-ups",
      "coding": "Programmieren",
      "cybersecurity": "Cybersicherheit",
      "web3": "Web3",
      "gadgets": "Gadgets",
      "esports": "E-Sport",
      "nature": "Natur",
      "sunsets": "Sonnenuntergänge",
      "photography_walks": "Fotospaziergänge",
      "picnics": "Picknicks",
      "fishing": "Angeln",
      "climbing": "Klettern",
      "kayaking": "Kajakfahren",
      "skiing": "Skifahren",
      "snowboarding": "Snowboarden",
      "wildlife": "Tierwelt",
      "netflix": "Netflix",
      "reading": "Lesen",
      "meditation": "Meditation",
      "spa": "Spa",
      "journaling": "Tagebuch schreiben",
      "podcasts": "Podcasts",
      "shopping": "Shopping",
      "minimalism": "Minimalismus",
      "self_growth": "Persönliche Entwicklung",
      "coffee": "Kaffee"
    }
  },
  "feed": {
    "free": "Kostenlos",
    "freeEntry": "Freier Eintritt",
    "paidEntry": "Eintritt kostenpflichtig",
    "ongoing": "Läuft",
    "nowOn": "Jetzt",
    "runsUntil": "Läuft bis",
    "until": "bis",
    "peopleGoing": "gehen hin",
    "peopleGoingCount_one": "{count} Person geht hin",
    "peopleGoingCount_few": "{count} Personen gehen hin",
    "peopleGoingCount_many": "{count} Personen gehen hin",
    "peopleGoingCount_other": "{count} Personen gehen hin",
    "tonyteVenue": "Tonyte-Location",
    "ticketsFrom": "Tickets ab",
    "eyebrow": "Offizielle Events und gehostete Erlebnisse in deiner Nähe",
    "whatsOnIn": "Was läuft in",
    "today": "Heute",
    "tomorrow": "Morgen",
    "date": "Datum",
    "gettingLocation": "Standort wird ermittelt...",
    "locationDenied": "Standortzugriff verweigert. Aktiviere ihn in den Einstellungen, um Events in der Nähe zu sehen.",
    "enableLocation": "Aktiviere den Standort, um Events in der Nähe zu sehen.",
    "featuredThisWeek": "Highlights der Woche",
    "topPicksForYou": "Top-Empfehlungen für dich",
    "popularNearYou": "Beliebt in deiner Nähe",
    "topPicksError": "Deine Empfehlungen konnten nicht geladen werden.",
    "topPicksSubtitle": "Events, die zu deinen Interessen passen",
    "topPicksSubtitlePopular": "Angesagte Events in deiner Nähe",
    "topPicksSeeAll": "Alle ansehen",
    "topPicksBadge": "Für dich",
    "topPicksEyebrow": "Für dich empfohlen",
    "topPicksReason": {
      "interest": "Weil du {interest} magst",
      "category": "Passt zu deinen {category}-Interessen",
      "joined": "Ähnlich wie Events, denen du beigetreten bist",
      "shared": "Ähnlich wie Events, die du geteilt hast",
      "viewed": "Basierend auf Events, die du dir angesehen hast"
    },
    "allEvents": "Alle Events",
    "searchPlaceholder": "Finde deinen nächsten Vibe …",
    "searchAccessibility": "Events, Clubs oder Tags suchen",
    "searchResults": "Suchergebnisse",
    "searchEmpty": "Keine Events zu „{query}“",
    "searchEmptySub": "Versuch einen anderen Namen, Club oder Tag.",
    "loadingEvents": "Events werden geladen...",
    "noEventsFound": "Keine Events gefunden",
    "noEventsSub": "Schau bald wieder vorbei oder probiere einen anderen Filter."
  },
  "featuredAdmin": {
    "title": "Event hervorheben",
    "thisWeek": "Diese Woche",
    "nextWeek": "Nächste Woche",
    "custom": "Eigener Zeitraum",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "priority": "Anzeigepriorität",
    "priorityHint": "1 wird zuerst angezeigt. Kleinere Zahlen erscheinen vor größeren.",
    "currentlyFeatured": "Dieses Event ist derzeit bei „Highlights der Woche“.",
    "save": "Speichern",
    "saveAnyway": "Trotzdem hervorheben",
    "remove": "Entfernen",
    "checkingPartner": "Partnerkonto wird geprüft…",
    "verifiedPartner": "Von einem verifizierten Tonyte-Partner erstellt.",
    "notPartner": "Dieses Event stammt nicht von einem verifizierten Partnerkonto. Hervorhebungen sind für Partner-Events gedacht.",
    "unknownPartner": "Das Partnerkonto konnte nicht überprüft werden. Hervorhebungen sind für Partner-Events gedacht.",
    "errors": {
      "invalidDate": "Gib Daten als JJJJ-MM-TT ein.",
      "endBeforeStart": "Das Enddatum muss nach dem Startdatum liegen.",
      "alreadyEnded": "Dieser Hervorhebungszeitraum ist bereits vorbei.",
      "invalidPriority": "Die Priorität muss eine ganze Zahl von 1 bis 999 sein.",
      "saveFailed": "Speichern nicht möglich. Bitte versuche es erneut."
    }
  },
  "map": {
    "loadingMap": "Karte wird geladen...",
    "showEvents": "Events anzeigen",
    "hide": "Ausblenden",
    "noMappedEvents": "Keine Events in der Nähe auf der Karte.",
    "noMappedEventsNearby": "Keine Events in der Nähe auf der Karte",
    "selectDate": "Datum auswählen",
    "selectCity": "Stadt auswählen",
    "myLocation": "Mein Standort",
    "locating": "Standort wird ermittelt…",
    "locationDeniedTitle": "Standortzugriff verweigert",
    "locationDeniedMsg": "Aktiviere den Standortzugriff in den Einstellungen, um diese Funktion zu nutzen.",
    "locationUnavailableTitle": "Standort nicht verfügbar",
    "locationUnavailableMsg": "Dein Standort konnte nicht ermittelt werden. Bitte versuche es erneut.",
    "locationUnavailable": "Standort nicht verfügbar",
    "locationPermissionDenied": "Standortzugriff verweigert",
    "locationUnavailableHint": "Aktiviere die Ortungsdienste und versuche es erneut.",
    "locationPermissionDeniedHint": "Erlaube den Standortzugriff in den Einstellungen, um deine Position zu verwenden.",
    "recenterToMyLocation": "Auf meinen Standort zentrieren",
    "invalidSharedLocation": "Dieser Standort kann gerade nicht angezeigt werden.",
    "dismissSharedLocation": "Geteilten Standort ausblenden"
  },
  "categories": {
    "social": "Social",
    "adventure": "Abenteuer",
    "culture": "Kultur",
    "food": "Essen",
    "nightlife": "Nachtleben"
  },
  "event": {
    "chatNoLongerAvailable": "Chat nicht mehr verfügbar",
    "chatNoLongerAvailableBody": "Diesen Chat gibt es nicht mehr, weil das Event vorbei ist.",
    "registerOnLumaFirst": "Die Plätze sind begrenzt – du meldest dich zuerst auf Luma an, danach geht es hier weiter.",
    "couldNotOpenRegistration": "Anmeldeseite konnte nicht geöffnet werden",
    "plan": "Plan",
    "communityPlan": "Community-Plan",
    "officialEvent": "Offizielles Event",
    "clubEvent": "Club-Event",
    "jamSession": "Jam Session",
    "tonight": "Heute Abend",
    "interested": "interessiert",
    "interestedCount_one": "{count} interessiert",
    "interestedCount_few": "{count} interessiert",
    "interestedCount_many": "{count} interessiert",
    "interestedCount_other": "{count} interessiert",
    "interestedBtn": "Interessiert",
    "members": "Mitglieder",
    "memberCount_one": "{count} Mitglied",
    "memberCount_few": "{count} Mitglieder",
    "memberCount_many": "{count} Mitglieder",
    "memberCount_other": "{count} Mitglieder",
    "eventChat": "Event-Chat",
    "joiningChat": "Verbinden…",
    "openVenue": "Location öffnen",
    "organizer": "Organisator",
    "leavePlan": "Plan verlassen",
    "requestSentShort": "Anfrage gesendet",
    "openChat": "Chat öffnen",
    "planChat": "Plan-Chat",
    "dateTba": "Datum TBA",
    "timeTba": "Zeit TBA",
    "decline": "Ablehnen",
    "accept": "Akzeptieren",
    "tonyteNight": "Eine Tonyte-Nacht, für die es sich lohnt zu erscheinen.",
    "lowRisk": "Geringes Risiko",
    "lowRiskSub": "Öffentlicher oder klar beschriebener Plan",
    "caution": "Vorsicht",
    "cautionSub": "Besondere Vorsicht empfohlen",
    "highRisk": "Hohes Risiko",
    "highRiskSub": "Private oder sensible Plandetails",
    "aboutThisPlan": "Über diesen Plan",
    "aboutThisEvent": "Über dieses Event",
    "detailsFinalized": "Details werden noch finalisiert.",
    "lineup": "Line-up",
    "genres": "Genres",
    "signInToJoinChats": "Melde dich an, um Event-Chats beizutreten.",
    "signInToMarkInterested": "Melde dich an, um Events als interessant zu markieren.",
    "signInToJoinPlans": "Melde dich an, um Plänen beizutreten.",
    "chatUnavailable": "Chat nicht verfügbar",
    "noEventChat": "Dieses Event hat keinen Event-Chat.",
    "couldNotJoinChat": "Chat konnte nicht geöffnet werden",
    "removedFromPlan": "Du wurdest aus diesem Plan entfernt.",
    "requestSent": "Anfrage gesendet!",
    "organizerWillReview": "Der Organisator prüft deine Anfrage.",
    "couldNotSendRequest": "Anfrage konnte nicht gesendet werden",
    "leftPlan": "Plan verlassen",
    "couldNotLeavePlan": "Plan konnte nicht verlassen werden",
    "planDeleted": "Plan gelöscht",
    "couldNotDeletePlan": "Plan konnte nicht gelöscht werden",
    "couldNotDeleteEvent": "Event konnte nicht gelöscht werden",
    "noDateAvailable": "Kein Datum verfügbar",
    "noScheduledTime": "Dieses Event hat noch keine geplante Uhrzeit.",
    "openingGoogleCalendar": "Google Kalender wird geöffnet...",
    "confirmCalendarSave": "Bestätige dort, um das Event zu speichern.",
    "deleteEventQuestion": "Event löschen?",
    "deleteEventConfirm": "Möchtest du dieses Event wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "joinEventChatQuestion": "Event-Chat beitreten?",
    "joinEventChatPrompt": "Möchtest du Interesse markieren und dem Event-Chat beitreten?",
    "interestedOnly": "Nur Interesse markieren",
    "joinChat": "Chat beitreten",
    "shareEvent": "Event teilen",
    "shareOutsideTonyte": "Außerhalb von Tonyte teilen",
    "sendInTonyteChat": "In Tonyte-Chat senden",
    "foundOnTonyte": "Auf Tonyte gefunden.",
    "openGoogleMaps": "In Google Maps öffnen",
    "openMaps": "In Karten öffnen",
    "couldNotOpenMaps": "Karten konnten nicht geöffnet werden",
    "couldNotOpenEventLink": "Event-Link konnte nicht geöffnet werden",
    "viewOfficialEvent": "Offizielles Event ansehen",
    "capacity": "Kapazität",
    "dateTime": "Datum & Uhrzeit",
    "calendar": "Kalender",
    "addToCalendar": "Zum Kalender hinzufügen",
    "publishedBy": "Veröffentlicht von",
    "openGoogleCalendar": "Google Kalender öffnen",
    "couldNotOpenCalendar": "Kalender konnte nicht geöffnet werden",
    "location": "Location",
    "exactLocationAfterApproval": "Der genaue Ort wird nach der Freigabe im Plan-Chat geteilt.",
    "joinRequests": "Beitrittsanfragen",
    "couldNotAccept": "Konnte nicht akzeptieren",
    "couldNotDecline": "Konnte nicht ablehnen",
    "requestToJoin": "Beitritt anfragen?",
    "highRiskWarning": "Dieser Plan könnte in einem privaten oder sensiblen Umfeld stattfinden. Bitte sei besonders vorsichtig.",
    "mediumRiskWarning": "Dieser Plan könnte Alkohol oder Nachtleben beinhalten. Achte auf deine Umgebung.",
    "ackRisks": "Ich verstehe die Risiken und möchte fortfahren",
    "messageOrganizerOptional": "Nachricht an den Organisator hinzufügen (optional)",
    "sendRequest": "Anfrage senden",
    "deleteEventConfirmShort": "Bist du sicher? Diese Aktion kann nicht rückgängig gemacht werden.",
    "requestToJoinFirst": "Erst Beitritt anfragen",
    "requestToJoinFirstMsg": "Sende eine Beitrittsanfrage, um nach Annahme auf den Plan-Chat zuzugreifen.",
    "cancelRequestQuestion": "Anfrage abbrechen?",
    "cancelRequestMsg": "Deine Beitrittsanfrage für diesen Plan zurückziehen?",
    "keepRequest": "Anfrage behalten",
    "cancelRequest": "Anfrage abbrechen",
    "couldNotCancel": "Konnte nicht abbrechen",
    "adminCannotLeave": "Plan-Admins können Pläne nicht verlassen.",
    "deletePlanInstead": "Diesen Plan stattdessen löschen?",
    "deletePlanQuestion": "Plan löschen?",
    "noStay": "Nein, bleiben",
    "yesDeletePlan": "Ja, Plan löschen",
    "venuePost": "Veranstaltungsortbeitrag",
    "hostedBy": "Gehostet von",
    "addComment": "Kommentar hinzufügen...",
    "comments": "Kommentare",
    "tonyteUser": "Tonyte Benutzer",
    "shareIntro": "Komm zu diesem Event auf Tonyte 🎉",
    "couldNotShare": "Teilen nicht möglich",
    "missingShareableId": "Für dieses Event fehlt eine teilbare ID.",
    "nativeShareUnavailable": "Das Teilen ist derzeit nicht verfügbar.",
    "missingExternalLink": "Dieses Event enthält noch keinen Link.",
    "couldNotUpdateInterest": "Interesse konnte nicht aktualisiert werden",
    "eventsCount_one": "{count} Event",
    "eventsCount_few": "{count} Events",
    "eventsCount_many": "{count} Events",
    "eventsCount_other": "{count} Events",
    "joinedCount_one": "{count} Person nimmt teil",
    "joinedCount_few": "{count} Personen nehmen teil",
    "joinedCount_many": "{count} Personen nehmen teil",
    "joinedCount_other": "{count} Personen nehmen teil"
  },
  "plans": {
    "myPlans": "Meine Pläne",
    "communityPlans": "Community-Pläne",
    "communityPlansSubtitle": "Schließe dich Gruppenabenteuern in deiner Nähe an",
    "communityPlanBadge": "COMMUNITY-PLAN",
    "freeBadge": "KOSTENLOS",
    "postedBy": "Gepostet von",
    "member": "Mitglied",
    "open": "Öffnen",
    "leave": "Verlassen",
    "request": "Anfragen",
    "loading": "Pläne werden geladen...",
    "noneYet": "Noch keine Community-Pläne",
    "noneYetSubtitle": "Erstelle einen Plan, lerne neue Leute kennen und entdeckt gemeinsam Neues.",
    "createPlan": "Plan erstellen",
    "completeProfile": "Vervollständige dein Profil, um Pläne zu sehen",
    "addRealProfilePicture": "Füge ein echtes Profilbild hinzu",
    "completeProfileSubtitle": "Ein echtes Profilbild ist erforderlich, bevor du Community-Plänen beitreten oder welche erstellen kannst.",
    "signInTitle": "Anmelden, um Pläne zu sehen",
    "signInSubtitle": "Erstelle ein Konto, um Gruppenabenteuern beizutreten und sie zu organisieren.",
    "signInRequiredSubtitle": "Du musst angemeldet sein, um Plänen beizutreten.",
    "leaveFailed": "Der Plan konnte nicht verlassen werden. Bitte versuche es erneut.",
    "planDeleted": "Plan gelöscht",
    "removed": "wurde entfernt.",
    "deleteFailed": "Der Plan konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "requestSent": "Anfrage gesendet!",
    "requestSentSubtitle": "Der Organisator des Plans prüft deine Anfrage.",
    "requestFailed": "Deine Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.",
    "deletePlan": "Plan löschen",
    "deletePlanConfirmPrefix": "Möchtest du",
    "deletePlanConfirmSuffix": "dauerhaft entfernen? Dies kann nicht rückgängig gemacht werden.",
    "templatesTitle": "Brauchst du eine Idee?",
    "templatesSubtitle": "Wähle einen Plan und mach ihn zu deinem."
  },
  "share": {
    "sentToChats": "An {count} Chat gesendet",
    "sentToChatsCount_one": "An {count} Chat gesendet",
    "sentToChatsCount_few": "An {count} Chats gesendet",
    "sentToChatsCount_many": "An {count} Chats gesendet",
    "sentToChatsCount_other": "An {count} Chats gesendet",
    "couldNotSend": "Konnte nicht senden. Bitte versuche es erneut."
  },
  "forms": {
    "searchAddressOrVenue": "Adresse oder Location suchen..."
  },
  "completeProfile": {
    "couldNotSave": "Konnte nicht gespeichert werden. Versuche es erneut.",
    "couldNotUploadCover": "Coverfoto konnte nicht hochgeladen werden.",
    "couldNotUploadProfilePhoto": "Profilfoto konnte nicht hochgeladen werden.",
    "doneTitle": "Profil verbessert!",
    "complete": "vollständig",
    "doneSub": "Dein Profil ist jetzt besser auffindbar. Bessere Empfehlungen, smartere Verbindungen und relevantere Events kommen auf dich zu.",
    "backToProfile": "Zurück zum Profil",
    "profileBoost": "PROFIL BOOST",
    "enhanceExperience": "Verbessere dein Erlebnis",
    "addProfilePicture": "Profilbild hinzufügen",
    "addProfilePictureSub": "Ein echtes Foto hilft anderen, dich in Vibes, Chats und Plänen zu erkennen.",
    "uploadPhoto": "Foto hochladen",
    "keepCurrent": "Aktuelles behalten",
    "skipStep": "Diesen Schritt überspringen",
    "dobTitle": "Dein Geburtsdatum",
    "dobSub": "Das kann nur einmal festgelegt werden und hält Tonyte altersgerecht.",
    "dobPlaceholder": "Tag, Monat, Jahr auswählen",
    "chooseDob": "Wähle dein Geburtsdatum, um fortzufahren.",
    "underMinAge": "Tonyte ist für Reisende ab 16 Jahren.",
    "saveContinue": "Speichern & weiter",
    "interestsTitle": "Was interessiert dich?",
    "interestsSub": "Wähle mindestens 3, damit Tonyte deine Empfehlungen abstimmen kann.",
    "selected": "ausgewählt",
    "pickInterests": "Wähle mindestens 3 Interessen.",
    "locationTitle": "Wo bist du zuhause?",
    "locationSub": "Deine Stadt hilft Tonyte, Menschen und Pläne relevant zu halten.",
    "city": "Stadt",
    "country": "Land",
    "addBaseCity": "Füge deine Stadt hinzu, um fortzufahren.",
    "bioTitle": "Erzähl deine Story",
    "bioSub": "Eine kurze Bio hilft anderen zu verstehen, wen sie treffen.",
    "bioPlaceholder": "Schreib etwas über dich - was dich begeistert, was du liebst, wofür du rausgehst...",
    "coverTitle": "Coverfoto hinzufügen",
    "coverSub": "Ein gutes Cover lässt dein Profil in Entdecken hervorstechen.",
    "tapChooseCover": "Tippen, um Cover auszuwählen",
    "uploadCover": "Cover hochladen",
    "vibeTitle": "Was ist dein Vibe?",
    "vibeSub": "Deine Reise-Persönlichkeit hilft uns, passende Events und Leute zu empfehlen.",
    "musicTitle": "Dein Musikgeschmack",
    "musicSub": "Wir finden Events passend zu deiner Musik. Wähle bis zu 5.",
    "languagesTitle": "Sprachen, die du sprichst",
    "languagesSub": "Finde Reisende, mit denen du wirklich sprechen kannst. Wähle alle passenden aus.",
    "goingOutTitle": "Ausgehstil",
    "goingOutSub": "Welche Art von Abenden magst du? Wähle alles Passende aus.",
    "saveFinish": "Speichern & fertig",
    "saveExit": "Speichern & schließen",
    "socialVibeButterfly": "Sozialer Schmetterling",
    "socialVibeButterflyDesc": "Es macht Ihnen Spaß, neue Leute kennenzulernen.",
    "socialVibeAdventurer": "Abenteurer",
    "socialVibeAdventurerDesc": "Sie suchen Nervenkitzel und neue Orte.",
    "socialVibeFoodie": "Feinschmecker",
    "socialVibeFoodieDesc": "Essen ist deine Liebessprache.",
    "socialVibeNightlife": "Liebhaber des Nachtlebens",
    "socialVibeNightlifeDesc": "Die besten Stunden sind nach Mitternacht.",
    "socialVibeCulture": "Kulturjäger",
    "socialVibeCultureDesc": "Museen, Kunst, Geschichte – alles.",
    "socialVibeChill": "Entspannend und entspannt",
    "socialVibeChillDesc": "Langsame Fahrt, gut vibes.",
    "music_techno": "Techno",
    "music_house": "Haus",
    "music_hipHop": "Hip Hop",
    "music_rAndB": "R&B",
    "music_pop": "Pop",
    "music_rock": "Rock",
    "music_indie": "Indie",
    "music_edm": "EDM",
    "music_jazz": "Jazz",
    "music_classical": "Klassisch",
    "music_reggaeton": "Reggaeton",
    "music_afrobeats": "Afrobeats",
    "music_loFi": "Lo-Fi",
    "music_drumBass": "Schlagzeug und Bass",
    "music_ambient": "Umgebung",
    "spoken_english": "Englisch",
    "spoken_german": "Deutsch",
    "spoken_french": "Französisch",
    "spoken_spanish": "Spanisch",
    "spoken_italian": "Italienisch",
    "spoken_portuguese": "Portugiesisch",
    "spoken_dutch": "Niederländisch",
    "spoken_polish": "Polnisch",
    "spoken_czech": "Tschechisch",
    "spoken_romanian": "Rumänisch",
    "spoken_greek": "Griechisch",
    "spoken_hungarian": "Ungarisch",
    "spoken_swedish": "Schwedisch",
    "spoken_danish": "Dänisch",
    "spoken_finnish": "Finnisch",
    "spoken_hindi": "Hindi",
    "spoken_ukrainian": "Ukrainisch",
    "spoken_russian": "Russisch",
    "spoken_arabic": "Arabisch",
    "spoken_chinese": "Chinesisch",
    "spoken_japanese": "Japanisch",
    "goingOutClubs": "Clubs und Partys",
    "goingOutBars": "Bars und Kneipen",
    "goingOutRooftops": "Dächer und Terrassen",
    "goingOutLiveMusic": "Live-Musik",
    "goingOutChill": "Chill Spots",
    "goingOutStreetFood": "Street Food & Märkte"
  },
  "profile": {
    "myVenueProfile": "Mein Partnerprofil",
    "myVenueProfileSub": "Sieh dein Venue so, wie Besucher es sehen",
    "basedIn": "Wohnhaft in",
    "locationNotAdded": "Standort nicht angegeben",
    "addBio": "Erzähl etwas über dich",
    "recently": "Kürzlich",
    "events": "Events",
    "plans": "Pläne",
    "interests": "Interessen",
    "attended": "Besucht",
    "created": "Erstellt",
    "saved": "Gespeichert",
    "memberSince": "Mitglied seit",
    "exploringSince": "Seit damals dabei.",
    "tapToChangeCity": "Feed- & Kartenstadt anpassen",
    "viewAll": "Alle anzeigen",
    "addInterest": "Interesse hinzufügen",
    "uploadEvent": "Event hochladen",
    "signOut": "Abmelden",
    "signOutConfirm": "Bist du sicher, dass du dich abmelden möchtest?",
    "cancel": "Abbrechen",
    "createAccountOrSignIn": "Konto erstellen oder anmelden",
    "logOut": "Abmelden",
    "personality": "Persönlichkeit",
    "editProfile": "Profil bearbeiten",
    "shareProfile": "Profil teilen",
    "qrCode": "QR-Code",
    "verifications": "Verifizierungen",
    "vibeVerified": "Vibe-verifiziert",
    "studentVerified": "Studentisch verifiziert",
    "earlyMember": "Frühes Mitglied",
    "topPlanner": "Top-Planer",
    "eventHost": "Event-Host",
    "aura": "Aura",
    "myPlans": "Meine Pläne",
    "loadingPlans": "Pläne werden geladen...",
    "upcomingPlansEmpty": "Deine kommenden Pläne erscheinen hier.",
    "createPlan": "Plan erstellen",
    "upcomingEvents": "Kommende Events",
    "loadingEvents": "Events werden geladen...",
    "upcomingEventsEmpty": "Noch keine kommenden Events.",
    "interestedEvents": "Interessierte Events",
    "loadingInterestedEvents": "Interessierte Events werden geladen...",
    "interestedEventsEmpty": "Events, die dich interessieren, erscheinen hier.",
    "browseEvents": "Events entdecken",
    "badgesAchievements": "Abzeichen & Erfolge",
    "savedTemplates": "Gespeicherte Vorlagen",
    "reusableEventDrafts": "Wiederverwendbare Event-Entwürfe",
    "uploadedPlans": "Hochgeladene Pläne",
    "yourCreatedPlans": "Deine erstellten Pläne",
    "planRequests": "Plan-Anfragen",
    "pendingPlanRequests": "Offene Beitrittsanfragen für deine Pläne",
    "todaysVibe": "Heutiger Vibe",
    "todaysVibePrompt": "Entdecke deinen Vibe",
    "todaysVibePromptSub": "Beantworte ein paar kurze Fragen",
    "loadingVibeMatches": "Vibe-Matches werden geladen...",
    "vibeMatchWaiting": "Vibe-Match wartet",
    "vibeMatchesWaiting": "Vibe-Matches warten",
    "vibeMatchWaitingCount_one": "{count} Vibe-Match wartet",
    "vibeMatchWaitingCount_few": "{count} Vibe-Matches warten",
    "vibeMatchWaitingCount_many": "{count} Vibe-Matches warten",
    "vibeMatchWaitingCount_other": "{count} Vibe-Matches warten",
    "following": "Folge ich",
    "followingSearch": "Partner durchsuchen, denen du folgst",
    "followingEmpty": "Du folgst noch keinen Partnern. Entdecke sie in Vibe at Venues.",
    "followingNoMatch": "Keine Partner passen zu deiner Suche.",
    "followingCount_one": "{count} Partner",
    "followingCount_few": "{count} Partner",
    "followingCount_many": "{count} Partner",
    "followingCount_other": "{count} Partner",
    "studiZoneOpen": "Öffnen",
    "studiZonePending": "Ausstehend",
    "studiZoneVerify": "Verifizieren",
    "updateRole": "Benutzerrolle aktualisieren?",
    "changeRole": "{name}s Rolle von {from} in {to} ändern?",
    "updateRoleAction": "Rolle aktualisieren",
    "noRolePermission": "Sie sind nicht berechtigt, diese Rolle zu aktualisieren.",
    "coAdminRoleRestriction": "Co-Administratoren können keine Administrator-/Co-Administratorkonten zuweisen oder ändern.",
    "adminSignInRequired": "Sie müssen als Administrator angemeldet sein, um Rollen zu aktualisieren.",
    "roleUpdateFailed": "Die Rolle kann derzeit nicht aktualisiert werden.",
    "roleUpdated": "Benutzerrolle aktualisiert.",
    "uploadingProfile": "Profilfoto wird hochgeladen…",
    "uploadingCover": "Titelbild wird hochgeladen…",
    "profileSaved": "Profilfoto gespeichert.",
    "coverSaved": "Titelbild gespeichert.",
    "imageUpdateFailed": "Bild konnte nicht aktualisiert werden",
    "removeProfilePhoto": "Profilfoto entfernen?",
    "removeCoverPhoto": "Titelbild entfernen?",
    "restoreDefault": "Dadurch wird das Standardbild wiederhergestellt.",
    "remove": "Entfernen",
    "imageRemoveFailed": "Bild konnte nicht entfernt werden",
    "interestsSaveFailed": "Interessen konnten nicht gespeichert werden",
    "notificationsSaveFailed": "Benachrichtigungen konnten nicht gespeichert werden",
    "reviewFailed": "Die Anfrage konnte nicht überprüft werden",
    "unchanged": "Bitte versuchen Sie es erneut – es wurde nichts geändert.",
    "revokeFailed": "Abzeichen konnte nicht widerrufen werden", "revokeSuccessTitle": "Vibe Verified entzogen", "revokeSuccessBody": "Das Vibe-Verified-Abzeichen dieses Nutzers wurde entfernt.",
    "shareFailed": "Konnte nicht geteilt werden",
    "missingShareId": "Diesem Profil fehlt eine gemeinsam nutzbare ID.",
    "shareUnavailable": "Das native Freigabeblatt ist derzeit nicht verfügbar.",
    "qrUnavailable": "QR nicht verfügbar",
    "vibesHub": "Vibes",
    "vibesHubSub": "Ihr persönlicher Chat und Ihre vibe-Verbindungen",
    "admin": "Admin",
    "userManagement": "Benutzerverwaltung",
    "usersCount": "{count}-Benutzer",
    "adminHelp": "Verwalten Sie Tonyte-Rollen für Benutzer, Tester, Organisatoren, Veranstaltungsorte, Co-Administratoren und Administratoren.",
    "userManagementSub": "Benutzer suchen und Rollen zuweisen.",
    "studentVerifications": "Studentenüberprüfungen",
    "faceVerificationRequests": "Anfragen zur Gesichtsverifizierung",
    "pendingReviewCount": "{count} wartet auf Überprüfung",
    "loading": "Wird geladen…",
    "change": "Ändern",
    "close": "Schließen",
    "myQrCode": "Mein QR-Code",
    "share": "Teilen",
    "coverPhoto": "Titelbild",
    "viewCover": "Cover anzeigen",
    "changeCover": "Deckung ändern",
    "removeCover": "Abdeckung entfernen",
    "pendingReviewCount_one": "{count} wartet auf Überprüfung",
    "pendingReviewCount_few": "{count}, Überprüfungen stehen noch aus",
    "pendingReviewCount_many": "{count}, Überprüfungen stehen noch aus",
    "pendingReviewCount_other": "{count}, Überprüfungen stehen noch aus",
    "tonyteTraveler": "Tonyte Reisender",
    "blockedAccountsLoadFailed": "Gesperrte Konten konnten derzeit nicht geladen werden.",
    "unblockFailed": "Dieses Konto konnte derzeit nicht entsperrt werden.",
    "noConnectedEmail": "Mit diesem Konto ist keine E-Mail-Adresse verknüpft.",
    "passwordResetSent": "Link zum Zurücksetzen des Passworts an {email} gesendet.",
    "passwordResetFailed": "Die E-Mail zum Zurücksetzen konnte momentan nicht gesendet werden.",
    "enterValidStudentEmail": "Geben Sie eine gültige Studenten-E-Mail-Adresse ein.",
    "studentVerificationEmailSent": "Bestätigungs-E-Mail gesendet! Überprüfen Sie Ihren Universitäts-Posteingang und klicken Sie zur Bestätigung auf den Link.",
    "studentVerificationEmailFailed": "Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "feedbackMessageRequired": "Bitte geben Sie eine Feedback-Nachricht ein.",
    "feedbackTypeRequired": "Bitte wählen Sie einen Feedbacktyp.",
    "feedbackThanks": "Danke, Feedback gesendet.",
    "feedbackSaveFailed": "Feedback konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    "feedbackType_general": "Allgemein",
    "feedbackType_bug": "Fehler",
    "feedbackType_feature": "Funktionsanfrage",
    "feedbackType_event_issue": "Ereignisproblem",
    "noSignedInUser": "Kein angemeldeter Benutzer gefunden.",
    "missingEmailForConfirmation": "In Ihrem Konto fehlt eine E-Mail-Adresse zur Passwortbestätigung.",
    "enterPasswordToContinue": "Bitte geben Sie Ihr Passwort ein, um fortzufahren.",
    "googleReauthUnavailable": "Die erneute Google-Authentifizierung ist in diesem Build nicht verfügbar.",
    "googleMissingIdToken": "Bei der erneuten Google-Authentifizierung wurde kein ID-Token zurückgegeben.",
    "appleReauthUnavailable": "Die erneute Apple-Authentifizierung ist auf diesem Gerät nicht verfügbar.",
    "appleMissingIdentityToken": "Bei der erneuten Apple-Authentifizierung wurde kein Identitätstoken zurückgegeben.",
    "deleteRequiresRecentLogin": "Bitte melden Sie sich erneut an, um die Kontolöschung zu bestätigen.",
    "deleteInvalidCredential": "Dieses Passwort oder diese Anmeldeinformationen wurden nicht akzeptiert. Bitte versuchen Sie es erneut.",
    "deleteUserMismatch": "Bitte authentifizieren Sie sich erneut mit demselben Konto, das derzeit bei Tonyte angemeldet ist.",
    "deleteReauthInterrupted": "Die erneute Authentifizierung wurde unterbrochen. Bitte versuchen Sie es erneut.",
    "deleteNetworkError": "Netzwerkfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "deletePermissionDenied": "Berechtigung verweigert. Bitte melden Sie sich erneut an und versuchen Sie es noch einmal.",
    "deleteFailedAtStage": "Konto löschen fehlgeschlagen bei {stage}: {error}",
    "deleteUnavailable": "Ihr Konto konnte derzeit nicht gelöscht werden.",
    "signInAgainBeforeDelete": "Bitte melden Sie sich erneut an, bevor Sie Ihr Konto löschen.",
    "mustSignInToDelete": "Sie müssen angemeldet sein, um Ihr Konto zu löschen.",
    "accountCleanupFailed": "Die HTTP-Anfrage zur Kontobereinigung ist fehlgeschlagen.",
    "selfieUnclear": "Selfie ist zu klein oder unklar. Bitte nehmen Sie es noch einmal bei gutem Licht auf, wobei Ihr Gesicht und Ihre Geste sichtbar sind.",
    "selfieRequired": "Machen Sie vor dem Absenden Ihr Bestätigungs-Selfie.",
    "verificationSyncPending": "Verifizierung eingereicht. Statussynchronisierung steht aus.",
    "verificationReviewFailed": "Überprüfung der Verifizierung fehlgeschlagen.",
    "vibeVerifiedApproved": "Zugelassen Vibe Verifiziert für {user}.",
    "verificationClearSelfieFailed": "Überprüfung fehlgeschlagen. Bitte versuchen Sie es noch einmal mit einem klaren Selfie.",
    "revokeNotConfirmed": "Der Widerruf hat den Erfolg nicht bestätigt.",
    "shareTitle": "Tonyte-Profil",
    "shareMessage": "Schauen Sie sich mein Tonyte-Profil an:\n{url}",
    "acceptSaveDomain": "Domain akzeptieren + speichern",
    "tonyteUser": "Tonyte Benutzer",
    "verificationEmailSentTitle": "Bestätigungs-E-Mail gesendet",
    "verificationPendingTitle": "Verifizierung steht aus",
    "verificationFailedTitle": "Überprüfung fehlgeschlagen",
    "studentVerificationTitle": "Studentenverifizierung",
    "verificationCheckInboxBody": "Bitte überprüfen Sie Ihren Posteingang und bestätigen Sie, dass diese E-Mail Ihnen gehört.",
    "verificationReviewingBody": "Wir überprüfen Ihren Studentenstatus.",
    "verificationFailedBody": "Wir konnten Ihren Studentenstatus nicht bestätigen. Bitte überprüfen Sie die E-Mails Ihres Studenten oder versuchen Sie es erneut.",
    "verificationUnlockBody": "Schalten Sie Studentenveranstaltungen, Erasmus-Treffen, Campus-Nachtleben, Veranstaltungen nur für Studenten, Pläne und Chats frei.",
    "studiZoneUnderConstruction": "StudiZone im Bau",
    "enterStudiZone": "Geben Sie StudiZone ein",
    "verifyStudentStatus": "Studentenstatus überprüfen",
    "faq1Question": "Was ist Tonyte?",
    "faq1Answer": "Tonyte hilft Ihnen bei discover-Veranstaltungen, bei der Teilnahme an Plänen und beim Treffen von Menschen in der Nähe, während Sie reisen oder in einer Stadt leben.",
    "faq2Question": "Ist Tonyte kostenlos?",
    "faq2Answer": "Ja, Kernfunktionen wie das Entdecken von Veranstaltungen, das Beitreten zu Plänen und das Chatten sind kostenlos.",
    "faq3Question": "Wer kann mein Profil sehen?",
    "faq3Answer": "Benutzer können Ihr Profil sehen, wenn Sie mit ihnen über Chats, Pläne, Veranstaltungen oder freigegebene Profillinks interagieren.",
    "faq4Question": "Was ist ein Plan?",
    "faq4Answer": "Ein Plan ist ein lockeres Treffen, das von einem Benutzer erstellt wurde, z. B. Kaffee, Grillen, Besichtigungen, Spiele oder Ausgehen.",
    "faq5Question": "Wer kann Pläne erstellen?",
    "faq5Answer": "Jeder angemeldete Benutzer kann einen Community-Plan erstellen.",
    "faq6Question": "Was passiert, wenn ich einem Plan beitrete?",
    "faq6Answer": "Sie können zur Teilnehmerliste des Plans hinzugefügt werden und Zugriff auf den Plan-Chat erhalten.",
    "faq7Question": "Kann ich einen Plan hinterlassen?",
    "faq7Answer": "Ja, normale Teilnehmer können einen Plan verlassen. Organisatoren können ihren eigenen Plan nicht verlassen, es sei denn, sie löschen ihn.",
    "faq8Question": "Kann mich ein Organisator aus einem Plan entfernen?",
    "faq8Answer": "Ja. Organisatoren können Personen aus ihren eigenen Plänen ausschließen, um Sicherheit und Komfort zu gewährleisten.",
    "faq9Question": "Was passiert, wenn ich aus einem Plan entfernt werde?",
    "faq9Answer": "Sie können diesem Plan nicht erneut beitreten, aber Sie können den Chat weiterhin ansehen und bei Bedarf den Plan oder bestimmte Benutzer melden.",
    "faq10Question": "Wer kann mir eine Nachricht senden?",
    "faq10Answer": "Menschen können Ihnen über Matches, Event-Chats oder Plan-Chats Nachrichten senden.",
    "faq11Question": "Warum kann ich in einem Chat keine Nachrichten senden?",
    "faq11Answer": "Möglicherweise sind Sie kein aktiver Teilnehmer mehr oder wurden aus diesem Plan/Chat entfernt.",
    "faq12Question": "Kann ich jemanden melden?",
    "faq12Answer": "Ja. Sie können Benutzer, Pläne, Ereignisse oder Chat-Verhalten melden, wenn sich etwas unsicher, beleidigend, diskriminierend oder unangemessen anfühlt.",
    "faq13Question": "Ist mein genauer Standort sichtbar?",
    "faq13Answer": "Nein. Der Standort wird verwendet, um Ereignisse und Pläne in der Nähe anzuzeigen. Ihr genauer Live-Standort wird anderen Benutzern nicht angezeigt.",
    "faq14Question": "Kann ich mein Profil bearbeiten?",
    "faq14Answer": "Ja. Sie können Ihren Namen, Ihre Stadt, Ihre Biografie, Ihre Fotos und Ihre Interessen jederzeit aktualisieren.",
    "faq15Question": "Wie lösche ich mein Konto?",
    "faq15Answer": "Gehen Sie zu Profileinstellungen → Konto löschen.",
    "faq16Question": "Die App funktioniert nicht ordnungsgemäß. Was soll ich tun?",
    "faq16Answer": "Nutzen Sie Hilfe und Feedback in den Einstellungen und beschreiben Sie das Problem."
  },
  "vibes": {
    "synchronize": "Synchronisieren",
    "lockInToday": "Heutigen Vibe fixieren",
    "getYourVibesSynchronized": "Synchronisiere\ndeine Vibes",
    "getYourVibesSynchronizedFlat": "Synchronisiere deine Vibes",
    "vibeCircle": "Vibe Circle",
    "vibeAlignment": "Vibe Alignment",
    "sharedFrequency": "Shared Frequency",
    "instantSync": "Instant Sync",
    "strongSync": "Strong Sync",
    "recommendedVibe": "Empfohlener Vibe",
    "openChat": "Chat öffnen",
    "continueChat": "Chat fortsetzen",
    "sendVibe": "Vibe senden",
    "startSync": "Sync starten",
    "pickAllHint": "Wähle alles, was zu deinem Vibe passt.",
    "dontOverthink": "Nicht zu viel nachdenken.",
    "pickUpTo": "Wähle bis zu",
    "couldNotSaveVibe": "Konnte nicht speichern",
    "couldNotSaveVibeSub": "Dein Vibe konnte noch nicht gespeichert werden. Bitte versuche es erneut.",
    "icebreakersReady": "Zwei Eisbrecher-Fragen warten in deinem Chat.",
    "suggestedIcebreaker": "Vorgeschlagener Eisbrecher",
    "signalLocked": "Signal fixiert",
    "signalsLocked": "Signale fixiert",
    "signalLockedCount_one": "{count} Signal fixiert",
    "signalLockedCount_few": "{count} Signale fixiert",
    "signalLockedCount_many": "{count} Signale fixiert",
    "signalLockedCount_other": "{count} Signale fixiert",
    "chooseOneSignal": "Wähle ein Signal",
    "chooseUpTo": "Wähle bis zu",
    "next": "Weiter",
    "microcopy0": "Nicht zu viel nachdenken.",
    "microcopy1": "Geh mit der Energie des heutigen Tages.",
    "microcopy2": "Das kann sich morgen ändern.",
    "microcopy3": "Nur der aktuelle Vibe.",
    "microcopy4": "Sei ehrlich.",
    "microcopy5": "Der erste Instinkt stimmt meistens.",
    "dayVibesBadge": "DAY VIBES",
    "questionOf": "Frage",
    "resultsUnlock1pm": "Ergebnisse werden um 13:00 Uhr freigeschaltet",
    "lastOne": "Die letzte!",
    "questionsLeft": "Fragen übrig",
    "questionLeft": "Frage übrig",
    "questionLeftCount_one": "{count} Frage übrig",
    "questionLeftCount_few": "{count} Fragen übrig",
    "questionLeftCount_many": "{count} Fragen übrig",
    "questionLeftCount_other": "{count} Fragen übrig",
    "openAt6am": "Der heutige Aura-Scan öffnet um 6:00 Uhr.",
    "resetDaily": "Neue Fragen und Vibe Circle Ergebnisse werden täglich zurückgesetzt.",
    "loadingAura": "Deine heutige Aura wird geladen...",
    "noAuraToday": "Für heute wurde keine Aura gefunden.",
    "goBack": "Zurück",
    "todaysAura": "Heutige Aura",
    "todayYouAre": "HEUTE BIST DU",
    "resultsIn": "Ergebnisse in",
    "basedOnToday": "Basierend auf deinen heutigen Day Vibes",
    "findingWavelength": "Menschen auf deiner Wellenlänge werden gesucht...",
    "noAlignmentYet": "Noch keine Vibe-Übereinstimmung",
    "noAlignmentSubtitle": "Noch hat niemand auf deiner Wellenlänge das heutige Spiel beendet. Neue Matches können dazukommen, wenn andere spielen – sie erscheinen hier automatisch.",
    "firstVibesUnlock": "Du bist dabei! Deine ersten Vibes werden um 13:00 Uhr freigeschaltet.",
    "moreMatchesLater": "Weitere Matches können dazukommen, wenn später noch Leute mitspielen – dein Vibe Circle aktualisiert sich den ganzen Tag.",
    "matchingInProgress": "Deine Vibes werden gesucht…",
    "matchingInProgressBody": "Wir gleichen dich mit allen ab, die heute gespielt haben. Das aktualisiert sich von selbst.",
    "matchingRetryingBody": "Das dauert gerade etwas länger als sonst – wir sind dran. Deine Vibes erscheinen hier automatisch.",
    "moreCanArrive": "Weitere Vibes können dazukommen, wenn andere das heutige Spiel beenden.",
    "resultsRightAway": "Ergebnisse direkt nach dem Spiel",
    "refresh": "Aktualisieren",
    "sync": "Sync",
    "sharedFrequencyToday": "gemeinsame Frequenz heute",
    "sharedFrequenciesToday": "gemeinsame Frequenzen heute",
    "alignmentPercentPrefix": "Deine Vibe-Übereinstimmung beträgt",
    "icebreakerPrompt1": "Wozu würdet ihr heute beide wirklich Ja sagen?",
    "icebreakerPrompt2": "In welcher Umgebung würde sich euer gemeinsamer Vibe ganz natürlich anfühlen?",
    "auraCitySoulName": "Stadtseele",
    "auraCitySoulDescription": "Heute strahlst du neugierige, filmische und leise abenteuerlustige Energie aus.",
    "auraCitySoulTrait1": "Stadtentdecker",
    "auraCitySoulTrait2": "Sanft gesellig",
    "auraCitySoulTrait3": "Ästhetischer Vibe",
    "auraSoftChaosName": "Sanftes Chaos",
    "auraSoftChaosDescription": "Spontane Pläne, soziale Funken und wunderschön unstrukturierte Energie.",
    "auraSoftChaosTrait1": "Spontan",
    "auraSoftChaosTrait2": "Café-Hopper",
    "auraSoftChaosTrait3": "Heute gesellig",
    "auraGoldenHourName": "Goldene Stunde",
    "auraGoldenHourDescription": "Heute bist du warm, gelassen und strahlst bewusste Präsenz aus.",
    "auraGoldenHourTrait1": "Bewusst",
    "auraGoldenHourTrait2": "Wärmesucher",
    "auraGoldenHourTrait3": "Im Moment",
    "auraNeonWolfName": "Neonwolf",
    "auraNeonWolfDescription": "Heute bist du mutig, aufgeladen und voller elektrischer, unabhängiger Energie.",
    "auraNeonWolfTrait1": "Unabhängig",
    "auraNeonWolfTrait2": "Elektrisierend mutig",
    "auraNeonWolfTrait3": "Bereit für die Nacht",
    "auraQuietStormName": "Stiller Sturm",
    "auraQuietStormDescription": "Heute bist du tief präsent, kreativ lebendig und leise kraftvoll.",
    "auraQuietStormTrait1": "Nachdenklich",
    "auraQuietStormTrait2": "Kreativ angetrieben",
    "auraQuietStormTrait3": "Tief aufmerksam",
    "auraSolarBurstName": "Sonnenexplosion",
    "auraSolarBurstDescription": "Heute bist du strahlend, magnetisch und voller nach außen gerichteter Energie.",
    "auraSolarBurstTrait1": "Voller Energie",
    "auraSolarBurstTrait2": "Strahlend offen",
    "auraSolarBurstTrait3": "Magnetisch gesellig",
    "reset": "Reset",
    "scan": "Scan",
    "auraBadgeAccessibility": "{name} aura Abzeichen",
    "auraBadgeHint": "Erweitert die heutige aura-Beschreibung"
  },
  "venues": {
    "vibeAtVenues": "Vibe in Locations"
  },
  "imageCrop": {
    "profilePhoto": "Profilfoto",
    "eventPhoto": "Eventfoto",
    "coverPhoto": "Titelbild",
    "frameProfile": "Profilfoto ausrichten",
    "frameEvent": "Eventfoto ausrichten",
    "frameCover": "Titelbild ausrichten",
    "previewBeforeSaving": "Prüfe das Bild vor dem Speichern.",
    "dragToReposition": "Foto zum Ausrichten ziehen",
    "fitEntireImage": "Ganzes Bild einpassen",
    "cropToFill": "Rahmen ausfüllen",
    "completeImageHint": "Das vollständige Bild wird gespeichert",
    "viewFullImage": "Vollständiges Eventbild anzeigen",
    "zoom": "Zoom",
    "cropping": "Wird zugeschnitten...",
    "useImage": "Bild verwenden"
  },
  "appUpdate": {
    "defaultTitle": "Tonyte ist jetzt noch besser",
    "defaultMessage": "Wir haben Karten, Pläne, Profile und das gesamte App-Erlebnis verbessert.",
    "newVersion": "Neue Version verfügbar",
    "newVersionNamed": "Neue Version {version} verfügbar",
    "opening": "Wird geöffnet...",
    "updateNow": "Jetzt aktualisieren",
    "optionalTitle": "Tonyte aktualisieren 🧡",
    "optionalMessage": "Eine neuere Version mit den neuesten Funktionen, Fehlerbehebungen und Verbesserungen ist verfügbar.",
    "requiredTitle": "Tonyte braucht ein Update",
    "requiredMessage": "Bitte aktualisiere Tonyte, um die App weiter zu nutzen.",
    "updateTonyte": "Tonyte aktualisieren",
    "notNow": "Nicht jetzt"
  },
  "languages": {
    "en": "Englisch",
    "de": "Deutsch",
    "es": "Spanisch",
    "fr": "Französisch",
    "ru": "Russisch"
  },
  "onboarding": {
    "languageTitle": "Wählen Sie Ihre Sprache",
    "languageSub": "Tonyte spricht ab jetzt Ihre Sprache. Sie können dies jederzeit in den Einstellungen ändern.",
    "travelerProfile": "Ihr Reiseprofil",
    "displayNameTitle": "Wie sollen Reisende Sie nennen?",
    "displayNameSub": "Wählen Sie einen Namen, der zu Ihnen passt.",
    "displayNameLabel": "NAME ANZEIGEN",
    "displayNamePlaceholder": "Ihr Anzeigename",
    "changeLater": "Sie können dies später ändern.",
    "continue": "Weiter",
    "photoTitle": "Fügen Sie Ihrem Profil ein Gesicht hinzu",
    "photoSub": "Ein Profilbild hilft anderen zu erkennen, wen sie treffen.",
    "tapUpload": "Zum Hochladen antippen",
    "addPhoto": "Profilbild hinzufügen",
    "skipNow": "Vorerst überspringen",
    "dobTitle": "Wie lautet Ihr Geburtsdatum?",
    "dobSub": "Dies hilft Tonyte, Pläne und Entdeckungen altersgerecht zu halten.",
    "dobLabel": "GEBURTSDATUM",
    "invalidDob": "Bitte wählen Sie ein gültiges Geburtsdatum.",
    "dobReady": "Geburtsdatum hinzugefügt – Weiter ist jetzt verfügbar.",
    "continueLocked": "Weiter · Geburtsdatum erforderlich",
    "interests": "Interessen",
    "selected20": "{count}/20 ausgewählt",
    "unlockStudiZone": "Schalte StudiZone frei",
    "unlockStudiZoneSub": "Bestätigen Sie Ihren Studentenstatus, um auf Veranstaltungen nur für Studenten, Erasmus-Pläne, Campus-Communitys und private Studenten-Chats zuzugreifen.",
    "campusEvents": "Campus-Veranstaltungen",
    "erasmusPlans": "Erasmus-Pläne",
    "studentChats": "Studentenchats",
    "verifiedGuestlist": "Verifizierte Gästeliste",
    "universityEmail": "E-MAIL DER UNIVERSITÄT",
    "universityEmailPlaceholder": "your@university.edu",
    "universityEmailHelp": "Geben Sie Ihre Universitäts-E-Mail-Adresse zur Überprüfung durch den Administrator ein. Kein Spam, niemals.",
    "submitVerification": "Zur Überprüfung einreichen",
    "skipVerification": "Vorerst überspringen – später im Profil überprüfen",
    "guidelinesTitle": "Community-Richtlinien",
    "guidelinesSub": "Tonyte basiert auf Vertrauen und Respekt. Lesen und stimmen Sie zu, bevor Sie beitreten.",
    "guidelineRespect": "Behandeln Sie jeden Reisenden mit Respekt – online und persönlich.",
    "guidelineHarassment": "Null Toleranz gegenüber Belästigung, Hassrede oder Missbrauch.",
    "guidelineRealEvents": "Veröffentlichen Sie nur echte, genaue Ereignisse und Pläne.",
    "guidelineSafety": "Priorisieren Sie die Sicherheit bei allen Treffen.",
    "guidelineData": "Ihre Daten sind geschützt. Wir verkaufen Ihre Daten nicht.",
    "guidelineReport": "Melden Sie schädliche Inhalte über die In-App-Flag-Schaltfläche.",
    "viewTerms": "Nutzungsbedingungen anzeigen",
    "viewPrivacy": "Datenschutzrichtlinie anzeigen",
    "agreeTerms": "Ich stimme den Nutzungsbedingungen und Community-Richtlinien zu",
    "enterTonyte": "Geben Sie Tonyte → ein",
    "skipPhotoTitle": "Profilbild überspringen?",
    "skipPhotoBody": "Ohne ein Profilbild können Sie möglicherweise nicht auf alle Funktionen wie Discover, den Beitritt zu Plänen oder das Erstellen von Plänen zugreifen.",
    "uploadPicture": "Bild hochladen",
    "skipAnyway": "Trotzdem überspringen",
    "displayNameMin": "Der Anzeigename muss mindestens 2 Zeichen lang sein.",
    "displayNameSaveFailed": "Anzeigename konnte nicht gespeichert werden.",
    "choosePhoto": "Wählen Sie ein Profilbild oder überspringen Sie es vorerst.",
    "photoSaveFailed": "Profilbild konnte nicht gespeichert werden.",
    "photoSkipFailed": "Profilbild konnte nicht übersprungen werden.",
    "dobRequired": "Geben Sie Ihr Geburtsdatum ein, um fortzufahren.",
    "ageRequirement": "Tonyte ist für Reisende ab {age} und älter. Bitte überprüfen Sie Ihr Geburtsdatum.",
    "profileSaveFailed": "Profil konnte nicht gespeichert werden.",
    "verificationSendFailed": "Bestätigungs-E-Mail konnte nicht gesendet werden. Überprüfen Sie die Adresse und versuchen Sie es erneut.",
    "skipFailed": "Überspringen konnte nicht durchgeführt werden.",
    "acceptTerms": "Bitte akzeptieren Sie die Nutzungsbedingungen und Community-Richtlinien, um fortzufahren.",
    "setupFailed": "Die Einrichtung konnte nicht abgeschlossen werden.",
    "themeKicker": "MACH TONYTE ZU DEINEM",
    "themeTitle": "Wähle deinen Look",
    "themeSubtitle": "Wähle die Seite von Tonyte, die sich nach dir anfühlt.",
    "themeDaylight": "TAGESLICHT",
    "themeDaylightDescriptor": "Hell · Warm · Sozial",
    "themeMidnight": "MITTERNACHT",
    "themeMidnightDescriptor": "Dunkel · Mutig · Elektrisierend",
    "themeSwitchAnytime": "Du kannst jederzeit in deinem Profil wechseln.",
    "themeNotPermanent": "Nicht dauerhaft — jederzeit in deinem Profil änderbar.",
    "themeEnter": "Tonyte betreten",
    "selectThemeRequired": "Wähle Tageslicht oder Mitternacht, um Tonyte zu betreten."
  },
  "library": {
    "myPosts": "Meine Beiträge",
    "profileEyebrow": "PROFIL",
    "events": "Ereignisse",
    "plans": "Pläne",
    "search": "Suche nach Titel, Veranstaltungsort, Stadt, Tags…",
    "loadingPosts": "Beiträge werden geladen…",
    "edit": "Bearbeiten",
    "repost": "Neu posten",
    "planEditing": "Planbearbeitung",
    "planEditingUnavailable": "Die Planbearbeitung ist noch nicht verfügbar.",
    "permissionRequired": "Erlaubnis erforderlich",
    "deletePermission": "Nur der Veranstalter oder Administratoren können diesen Beitrag löschen.",
    "deletePost": "Beitrag löschen",
    "deletePostFailed": "Beitrag konnte nicht gelöscht werden. Versuchen Sie es erneut.",
    "organizerLibrary": "ORGANIZER-BIBLIOTHEK",
    "savedTemplates": "Gespeicherte Vorlagen",
    "loadingTemplates": "Vorlagen werden geladen…",
    "eventTemplate": "EREIGNISVORLAGE",
    "useTemplate": "Vorlage verwenden",
    "deleteTemplate": "Vorlage löschen",
    "deleteTemplateFailed": "Vorlage konnte nicht gelöscht werden. Versuchen Sie es erneut.",
    "deleteConfirm": "„{title}“ löschen? Dies kann nicht rückgängig gemacht werden.",
    "noMatches": "Keine Übereinstimmungen",
    "noPosts": "Noch keine Beiträge",
    "searchAgain": "Versuchen Sie es mit einem anderen Suchbegriff.",
    "noPostsSub": "Erstellen Sie zunächst eine Veranstaltung oder einen Community-Plan.",
    "communityPlan": "GEMEINSCHAFTSPLAN",
    "officialEvent": "OFFIZIELLE VERANSTALTUNG",
    "noTemplates": "Keine gespeicherten Vorlagen",
    "noTemplatesSub": "Erstellen Sie ein Ereignis und speichern Sie es als Vorlage zur schnellen Wiederverwendung.",
    "untitled": "Ohne Titel",
    "noVenue": "Kein Veranstaltungsort"
  },
  "planRequests": {
    "empty": "Keine ausstehenden Anfragen",
    "emptySub": "Beitrittsanfragen aus Ihren Community-Plänen werden hier angezeigt.",
    "new": "NEU",
    "noMessage": "Keine Nachricht",
    "decline": "Ablehnen",
    "accept": "Akzeptieren",
    "acceptFailed": "Anfrage konnte nicht angenommen werden. Bitte versuchen Sie es erneut.",
    "declineFailed": "Anfrage konnte nicht abgelehnt werden. Bitte versuchen Sie es erneut.",
    "studiZoneAdmin": "STUDIZONE ADMIN",
    "planAdmin": "PLAN-ADMIN",
    "studiZoneRequests": "StudiZone Anfragen",
    "joinRequests": "Beitrittsanfragen",
    "traveler": "Reisender",
    "communityPlan": "Gemeinschaftsplan",
    "viewProfile": "Profil ansehen",
    "profileUnavailable": "Profil nicht verfügbar",
    "profileUnavailableBody": "Das Profil dieser Person konnte nicht gefunden werden."
  },
  "publicProfile": {
    "reportFailed": "Bericht konnte nicht gesendet werden",
    "blockTitle": "Benutzer blockieren?",
    "blockFailed": "Benutzer konnte nicht blockiert werden",
    "profileUnavailableTitle": "Profil nicht verfügbar",
    "profileUnavailableBody": "Dieses Profil existiert nicht mehr oder ist gerade nicht verfügbar.",
    "vibeScore": "VIBE PUNKT",
    "match": "% Übereinstimmung",
    "unvibe": "Unvibe",
    "report": "Bericht",
    "about": "Über",
    "publicPlans": "Öffentliche Pläne",
    "publicEvents": "Öffentliche Veranstaltungen",
    "safetyHint": "Melde- und Blockierungsaktionen sind in Ihrem direkten Chat-Menü verfügbar.",
    "safety": "SICHERHEIT",
    "optionalDetails": "Optionale Details...",
    "unvibeWith": "Unvibe mit {name}?",
    "unvibeBody": "Dadurch werden Ihre Verbindung und Ihr direkter Chat entfernt.",
    "keepVibe": "Vibe behalten",
    "community": "Tonyte-Community",
    "reportSubmitted": "Bericht eingereicht",
    "blockMessage": "Sie werden keine Nachrichten mehr von {name} sehen. Die Blockierung erfolgt nur in eine Richtung und benachrichtigt sie nicht.",
    "userBlocked": "Benutzer blockiert",
    "vibeSent": "Vibe wird an {name} gesendet",
    "vibeSendFailed": "vibe konnte nicht gesendet werden",
    "noLongerVibing": "Sie und {name} schwingen nicht mehr",
    "unvibeFailed": "Konnte momentan nicht deaktiviert werden",
    "message": "Nachricht",
    "vibeSentStatus": "Vibe Gesendet",
    "sendVibe": "Senden Sie Vibe",
    "blocking": "Blockierung...",
    "block": "Blockieren",
    "reportPerson": "Bericht {name}",
    "sending": "Senden...",
    "submitReport": "Bericht einreichen",
    "removing": "Entfernen...",
    "reasonSpam": "Spam",
    "reasonHarassment": "Belästigung",
    "reasonFake": "Gefälschtes Profil",
    "reasonContent": "Unangemessener Inhalt",
    "reasonScam": "Betrug oder unsicheres Verhalten",
    "reasonOther": "Sonstiges",
    "eventFallback": "Ereignis",
    "planFallback": "Planen"
  },
  "nudges": {
    "notNow": "Jetzt nicht",
    "photo": {
      "cta": "Foto hinzufügen",
      "v0": {
        "title": "Mystery-Guest-Vibes 👀",
        "body": "Dein Profil hat gerade Mystery-Guest-Energie. Füg ein Foto hinzu, damit alle wissen, wer beim Plan dabei ist."
      },
      "v1": {
        "title": "Großer Auftritt? 📸",
        "body": "Wir lieben einen großen Auftritt – aber ein Profilfoto wäre vielleicht ein guter Anfang."
      },
      "v2": {
        "title": "Gesicht zum Namen 🙂",
        "body": "Mit Profilfoto sagen Leute viel leichter Ja zu deinen Plänen."
      }
    },
    "verification": {
      "cta": "Vibe Verified werden",
      "retryCta": "Status ansehen",
      "v0": {
        "title": "Main Character? Beweis es. ✨",
        "body": "Dein Vibe-Verified-Badge wartet. Es zeigt, dass du wirklich du bist – dauert etwa eine Minute."
      },
      "v1": {
        "title": "Orange steht dir 🧡",
        "body": "Ein kleiner oranger Haken könnte dir richtig gut stehen. Komplett freiwillig, sehr glänzend."
      },
      "retry0": {
        "title": "Neuer Versuch? 📸",
        "body": "Dein letzter Vibe-Verified-Check hat nicht geklappt. Gutes Licht und ein klares Selfie helfen meistens – Details findest du auf deiner Statusseite."
      }
    },
    "survey": {
      "cta": "Feedback geben",
      "later": "Später erinnern",
      "never": "Nicht mehr fragen",
      "v0": {
        "title": "Eine Woche dabei 🎉",
        "body": "Du bist seit einer Woche mit Tonyte unterwegs. Sei ehrlich – was ist gut, was ist komisch, was muss besser werden? 👀"
      },
      "v1": {
        "title": "Zwei Minuten Zeit? ⏱️",
        "body": "Fünf kurze Fragen, keine falschen Antworten. Sag uns, was funktioniert und was nicht."
      }
    }
  },
  "feedbackSurvey": {
    "kicker": "Tonyte-Feedback",
    "progress": "Frage {step} von {total}",
    "back": "Zurück",
    "next": "Weiter",
    "skip": "Überspringen",
    "close": "Schließen",
    "otherLabel": "Anderes",
    "otherPlaceholder": "Erzähl uns mehr (optional)",
    "version": {
      "question": "Nutzt du die neueste Version von Tonyte?",
      "hint": "Wir prüfen deine installierte Version so oder so.",
      "check": "Nach Updates suchen",
      "already": "Ich habe schon aktualisiert",
      "checking": "Version wird geprüft…",
      "outdatedTitle": "Es gibt ein neueres Tonyte 🚀",
      "outdatedBody": "Version {version} ist da. Aktualisiere zuerst, damit dein Feedback das neueste Tonyte betrifft – wir öffnen die Umfrage etwa eine Woche, nachdem wir das Update sehen.",
      "openStore": "Store öffnen",
      "stillOldTitle": "Noch die ältere Version",
      "stillOldBody": "Wir sehen noch die vorherige Version. Sobald das Update installiert ist, laden wir dich etwa eine Woche später zur Umfrage ein.",
      "unknownTitle": "Version konnte nicht geprüft werden",
      "unknownBody": "Wir erreichen Tonyte gerade nicht. Prüfe deine Verbindung und versuch es nochmal – nichts geht verloren.",
      "retry": "Nochmal versuchen",
      "updatedTitle": "Danke fürs Aktualisieren 🧡",
      "updatedBody": "Schau dich in der neuen Version um – wir laden dich in etwa einer Woche zur Umfrage ein."
    },
    "q": {
      "primaryUse": {
        "title": "Wofür nutzt du Tonyte am meisten?",
        "finding_events": "Events finden",
        "making_plans": "Pläne machen",
        "meeting_people": "Leute kennenlernen",
        "browsing": "Schauen, was los ist"
      },
      "foundSomething": {
        "title": "Wie oft hast du über Tonyte etwas gefunden, das du machen wolltest?",
        "often": "Oft",
        "sometimes": "Manchmal",
        "once": "Einmal",
        "not_yet": "Noch nicht"
      },
      "hardestPart": {
        "title": "Was war bei Tonyte bisher am schwierigsten?",
        "finding_events": "Passende Events finden",
        "finding_people_plans": "Leute oder Pläne finden",
        "understanding": "Verstehen, wie etwas funktioniert",
        "bugs_slow": "Fehler oder langsames Laden",
        "nothing": "Bisher nichts"
      },
      "moreUseful": {
        "title": "Was würde Tonyte für dich nützlicher machen?",
        "more_events": "Mehr Events",
        "more_people_plans": "Mehr Leute und Pläne",
        "better_recommendations": "Bessere Empfehlungen",
        "easier_navigation": "Einfachere Navigation",
        "better_performance": "Bessere Performance"
      },
      "rating": {
        "title": "Wie würdest du deine bisherige Erfahrung mit Tonyte insgesamt bewerten?",
        "star": "{count} von 5 Sternen",
        "commentLabel": "Was sollten wir verbessern oder beibehalten?",
        "commentPlaceholder": "Optional"
      }
    },
    "submit": "Feedback senden",
    "submitting": "Wird gesendet…",
    "ratingRequired": "Wähle eine Sternebewertung zum Absenden – alles andere ist optional.",
    "submitFailed": "Feedback konnte nicht gesendet werden. Prüfe deine Verbindung und versuch es nochmal.",
    "thanksTitle": "Danke! 🧡",
    "thanksBody": "Jede Antwort hilft uns, Tonyte besser zu machen. Wir lesen alles.",
    "done": "Fertig",
    "tooNewTitle": "Fast geschafft",
    "tooNewBody": "Die Feedback-Umfrage öffnet nach deiner ersten Woche mit Tonyte. Schau dich noch etwas um und komm dann wieder!",
    "waitTitle": "Bis bald",
    "waitBody": "Danke fürs Aktualisieren! Die Umfrage öffnet am {date}, wenn du Zeit mit der neuen Version hattest.",
    "submittedTitle": "Du hast schon Feedback gegeben",
    "submittedBody": "Nochmals danke – wir haben deine Antworten für diese Umfrage.",
    "inactiveBody": "Gerade läuft keine Umfrage."
  },
  "optionalSettings": {
    "feedbackSection": "Feedback",
    "giveFeedback": "Feedback geben",
    "giveFeedbackSub": "Fünf kurze Fragen – sag uns, was gut ist und was nicht",
    "rateTonyte": "Tonyte bewerten",
    "rateTonyteSub": "Hinterlasse eine Bewertung im {store}",
    "appStore": "App Store",
    "playStore": "Play Store",
    "versionLabel": "Version {version}",
    "webVersion": "Web",
    "profileReminderNotifications": "Profil-Erinnerungen",
    "reviewReminderNotifications": "Bewertungs-Erinnerungen",
    "feedbackReminderNotifications": "Feedback-Erinnerungen"
  },
  "optionalNotifications": {
    "profileReminderTitle": "Dein Tonyte-Profil",
    "profileReminderBody": "Ein kurzes Profil-Update wartet auf dich.",
    "reviewReminderTitle": "Tonyte 🧡",
    "reviewReminderBody": "Hast du kurz Zeit, Tonyte im Store zu bewerten?"
  },
  partnerQr: {
    "scan": "Scannen und unsere Events auf Tonyte sehen",
    "shareImage": "QR-Code teilen",
    "shareLink": "Link teilen",
    "hint": "Teile den QR-Code auf Instagram, WhatsApp oder drucke ihn aus – beim Scannen öffnet sich dieses Profil in Tonyte.",
    "hintWeb": "Mach einen Screenshot vom QR-Code, um ihn überall zu teilen – beim Scannen öffnet sich dieses Profil in Tonyte."
  },
  partnerCalendar: {
    "by": "Von {name}",
    "interestedCount": "{count} interessiert",
    "kicker": "Partner",
    "title": "Mein Kalender",
    "manage": "Meinen Kalender verwalten",
    "entrySub": "Entwürfe, geplante, wiederkehrende und abgesagte Events an einem Ort",
    "intro": "Dein Tonyte-Kalender: Entwürfe planen, Veröffentlichung terminieren, Events wöchentlich wiederholen und einzelne Termine absagen. Öffentlich sichtbar sind nur veröffentlichte Events.",
    "new": "Neu",
    "untitled": "Event ohne Titel",
    "noLocation": "Noch kein Ort",
    "repeats": "Wiederholt",
    "missingCount": "{count} fehlen",
    "today": "Heute",
    "events": "Events",
    "lumaConnected": "Luma-Kalender verbunden – neue Luma-Events kommen hier als Entwürfe zur Prüfung an.",
    "paused": "pausiert",
    "lumaSkipped": "{count} Luma-Event(s) sehen aus wie Events, die du hier schon erstellt hast, und wurden deshalb nicht doppelt importiert. Prüfe sie im Partnerportal.",
    "all": "Alle",
    "needsDetails": "Details fehlen",
    "prevMonth": "Vorheriger Monat",
    "nextMonth": "Nächster Monat",
    "addOnDay": "Event hinzufügen",
    "nothingThisDay": "An diesem Tag ist noch nichts geplant.",
    "upcoming": "Bevorstehend",
    "past": "Vergangen",
    "noEvents": "Hier gibt es noch keine Events.",
    "portalHint": "Wiederholung ändern oder Luma verbinden? Öffne das Partnerportal auf tonyte.app.",
    "view": {
      "month": "Monat",
      "list": "Liste"
    },
    "status": {
      "draft": "Entwurf",
      "scheduled": "Geplant",
      "published": "Veröffentlicht",
      "cancelled": "Abgesagt",
      "past": "Vergangen"
    },
    "source": {
      "tonyte": "Tonyte",
      "luma": "Mit Luma synchronisiert",
      "luma-detached": "Von Luma · in Tonyte bearbeitet",
      "import": "Importiert"
    },
    "seriesInfo": "{count} Termine bis {until}",
    "when": "Wann",
    "where": "Wo",
    "entry": "Eintritt",
    "free": "Kostenlos",
    "paid": "Kostenpflichtig",
    "notConfirmed": "Noch nicht bestätigt",
    "editedSeparately": "dieser Termin wurde einzeln bearbeitet",
    "goesLive": "Geht live",
    "scheduleFailed": "Geplante Veröffentlichung fehlgeschlagen",
    "legacyRecurring": "Dieses ältere wiederkehrende Event ist nur ein einzelner Termin. Erstelle ein neues wiederkehrendes Event, um einen Eintrag pro Termin zu erhalten.",
    "beforePublishing": "Vor dem Veröffentlichen ergänzen",
    "scopeLegend": "Änderungen anwenden auf",
    "scope": {
      "one": "Nur diesen Termin",
      "future": "Diesen und alle folgenden Termine"
    },
    "publishAt": "Veröffentlichen am (Berliner Zeit)",
    "pickTime": "Wähle Datum und Uhrzeit für die Veröffentlichung.",
    "saveDraft": "Entwurf speichern",
    "editingOne": "Du bearbeitest nur diesen Termin. Die anderen Termine der Serie bleiben unverändert.",
    "editingFuture": "Du bearbeitest diesen und alle folgenden Termine (einzeln bearbeitete Termine bleiben unverändert). Die Wiederholung änderst du im Partnerportal.",
    "action": {
      "edit": "Bearbeiten",
      "duplicate": "Duplizieren",
      "publish": "Veröffentlichen",
      "schedule": "Planen",
      "unpublish": "Zurückziehen",
      "cancel": "Event absagen",
      "restore": "Wiederherstellen",
      "detach": "Nur in Tonyte bearbeiten",
      "delete": "Löschen"
    },
    "confirm": {
      "publish": "Dieses Event veröffentlichen? Es wird für alle auf Tonyte sichtbar.",
      "publishFuture": "Diesen und alle folgenden Entwurfstermine der Serie veröffentlichen?",
      "unpublish": "Dieses Event zurück zu den Entwürfen verschieben? Es verschwindet aus Feed, Karte und deinem öffentlichen Profil.",
      "cancel": "Dieses Event absagen? Es bleibt als abgesagt in deinem Kalender und verschwindet aus öffentlichen Ansichten. Du kannst es später wiederherstellen.",
      "cancelFuture": "Diesen und alle folgenden Termine der Serie absagen?",
      "detach": "Synchronisierung mit Luma für dieses Event beenden? Deine Änderungen in Tonyte werden dann nicht mehr von Luma überschrieben.",
      "delete": "„{title}“ endgültig löschen? Das kann nicht rückgängig gemacht werden.",
      "deleteSeriesDate": "Es wird nur dieser Termin der Serie gelöscht."
    },
    "luma": {
      "synced": "Dieses Event wird aus deinem Luma-Kalender synchronisiert.",
      "detached": "Von Luma importiert, jetzt nur in Tonyte bearbeitet – Änderungen aus Luma gelten nicht mehr.",
      "cancel": "Eine Absage hier bleibt auf Tonyte bestehen, auch wenn das Event auf Luma noch gelistet ist.",
      "delete": "Löschen entfernt es von Tonyte; Luma bringt es nicht zurück.",
      "detach": "Mit „Nur in Tonyte bearbeiten“ verhinderst du Updates durch Luma."
    },
    "done": {
      "duplicated": "Als Entwurf dupliziert.",
      "published": "Veröffentlicht.",
      "publishedMany": "{count} Termine veröffentlicht.",
      "unpublished": "Zurück zu den Entwürfen verschoben.",
      "cancelled": "Event abgesagt.",
      "cancelledMany": "{count} Termine abgesagt.",
      "restored": "Als Entwurf wiederhergestellt.",
      "detached": "Wird jetzt nur in Tonyte bearbeitet.",
      "deleted": "Event gelöscht.",
      "scheduled": "Veröffentlichung geplant für {date}."
    },
    "note": {
      "published": "Veröffentlichte Events erscheinen im Feed, auf der Karte und in deinem öffentlichen Profil.",
      "draft": "Entwürfe und geplante Events sind privat – nur du und Tonyte-Admins sehen sie.",
      "cancelled": "Abgesagte Events siehst nur du, als abgesagt markiert."
    }
  },
  "promotions": {
    "sectionTitle": "Sammlungen",
    "explore": "Events entdecken",
    "eventsCount": "{count} Events",
    "collection": "Sammlung",
    "runs": "Läuft {range}",
    "dateRangeNote": "Events über diesen Zeitraum – nicht nur am im Feed gewählten Tag.",
    "unavailableTitle": "Diese Sammlung ist nicht verfügbar",
    "unavailableSub": "Sie ist vielleicht beendet oder wurde entfernt. Im Event-Feed findest du, was gerade los ist.",
    "backToEvents": "Zurück zu den Events"
  },
  "studiZone": {
    "locked": "StudiZone Gesperrt",
    "lockedSub": "Bestätigen Sie Ihren Studentenstatus, um Studentenveranstaltungen, Erasmus-Treffen, Campuspläne und das Nachtleben der Universität freizuschalten.",
    "verifyStatus": "Studentenstatus überprüfen",
    "underConstruction": "im Bau",
    "constructionSub": "Wir geben StudiZone den letzten Schliff. Ihr verifizierter Status wird gespeichert – Sie haben beim Start vollen Zugriff.",
    "verifiedLayer": "Verifizierter Studenten-Layer",
    "exit": "Beenden",
    "loading": "Laden StudiZone...",
    "createPlan": "Studentenplan erstellen",
    "planChat": "StudiZone-Plan-Chat · {count}-Mitglieder",
    "unlockedSub": "Für dieses Profil sind Tarife nur für Studenten, Chats und Campus-Nachtleben freigeschaltet.",
    "planRequests": "Plananfragen",
    "soon": "Bald",
    "campusMap": "Campusplan",
    "studentPins": "{count} Studenten-Pins",
    "openMap": "Vollständige Karte öffnen",
    "emptyLane": "Noch nichts auf dieser Spur",
    "emptyLaneSub": "StudiZone ist bereit für Drops nur für Studenten, Vereine, Campus-Events und Erasmus-Pläne.",
    "loadingMap": "Schülerkarte wird geladen...",
    "mapTitle": "Campusplan",
    "pins": "StudiZone-Pins",
    "tonyteStudent": "Tonyte Student",
    "studentDiscounts": "Studentenrabatte",
    "universityCommunities": "Universitätsgemeinschaften",
    "societiesClubs": "Vereine und Vereine",
    "campusHeatmaps": "Campus-Heatmaps",
    "categoryAll": "Alle",
    "categoryCampus": "Campus",
    "categoryParties": "Parteien",
    "categoryErasmus": "Erasmus",
    "categoryWorkshops": "Workshops",
    "categorySports": "Sport",
    "categoryFree": "Kostenlos",
    "tabFeed": "Feed",
    "hey": "Hey {name}",
    "upcoming": "Demnächst",
    "eventsCount": "{count} Events",
    "today": "Heute",
    "tomorrow": "Morgen",
    "free": "Gratis",
    "verified": "Verifiziert",
    "timeTba": "Zeit folgt",
    "campusMapSub": "Sieh, was rund um den Campus los ist",
    "searchUniversities": "Hochschulen suchen",
    "dresden": "Dresden",
    "campusEventsCount": "{count} Campus-Events",
    "noCampusEvents": "Noch keine Events auf diesem Campus",
    "noCampusEventsSub": "Events mit einem Gebäude auf diesem Campus erscheinen hier.",
    "buildingFilter": "Gebäude {code}",
    "noUniversityResults": "Keine Hochschule gefunden",
    "yourUniversity": "Deine Uni",
    "campusesCount": "{count} Standorte",
    "allEvents": "Alle StudiZone-Events",
    "tabPlans": "Pläne",
    "tabChats": "Chats",
    "tabProfile": "Profil"
  },
  "verification": {
    "signInSub": "Bitte melden Sie sich an, um mit der Verifizierung zu beginnen.",
    "title": "Verifizierungszentrum",
    "subtitle": "Verwalten Sie Vertrauensausweise und optionalen StudiZone-Zugriff von einem Ort aus.",
    "vibe": "Vibe Überprüfung",
    "retake": "Wiederholen",
    "student": "Studentenverifizierung",
    "emailPlaceholder": "name@university.edu",
    "backToTonyte": "Zurück zu Tonyte",
    "validStudentEmail": "Geben Sie eine gültige Studenten-E-Mail-Adresse ein.",
    "emailSent": "Bestätigungs-E-Mail gesendet. Überprüfen Sie Ihren Universitäts-Posteingang.",
    "emailSendFailed": "Bestätigungs-E-Mail konnte nicht gesendet werden.",
    "selfieTooSmall": "Selfie ist zu klein oder unklar. Nehmen Sie es noch einmal bei gutem Licht und sichtbarem Gesicht auf.",
    "submitted": "Zur Überprüfung eingereicht.",
    "submitFailed": "Bestätigung konnte nicht übermittelt werden.",
    "verified": "Verifiziert",
    "pending": "Ausstehend",
    "failed": "Fehlgeschlagen",
    "notVerified": "Nicht überprüft",
    "vibeDescription": "Ein Vertrauens- und Sicherheitsabzeichen, das anderen Menschen zeigt, dass Ihr Profil einer echten Person gehört. Ihr Verifizierungs-Selfie wird manuell überprüft und nach Abschluss der Verifizierungsentscheidung gelöscht.",
    "studentDescription": "Optionale Verifizierung für Personen, die Zugriff auf StudiZone wünschen. Es ändert nichts am Haupterlebnis von Tonyte.",
    "pendingReview": "Überprüfung steht aus",
    "tryAgain": "Versuchen Sie es erneut",
    "start": "Verifizierung starten",
    "submitting": "Einreichen...",
    "submitReview": "Zur Überprüfung einreichen",
    "poseGuideTitle": "Werde Vibe Verifiziert",
    "poseGuideBody": "Schneller Gesichtscheck\n\nWir machen automatisch drei Fotos:\n• Geradeaus schauen\n• Nach links schauen\n• Nach rechts schauen\n\nAchte darauf, dass dein Gesicht gut sichtbar ist und du bei guter Beleuchtung bist.\n\nDeine Fotos werden sicher zur Verifizierung übermittelt und können vom Tonyte-Team überprüft werden.",
    "poseGuideOpenCamera": "Weiter",
    "camera": {
      "requestingPermission": "Kamerazugriff wird angefragt…",
      "permissionDenied": "Kamerazugriff wird benötigt, um deinen Vibe zu bestätigen. Aktiviere ihn in den Einstellungen und versuche es erneut.",
      "openSettings": "Einstellungen öffnen",
      "onePersonOnly": "Es sollte nur eine Person im Bild sein",
      "of": "von",
      "moveIntoFrame": "Bewege dein Gesicht ins Bild",
      "lookStraight": "Schau geradeaus in die Kamera",
      "turnLeft": "Zeige dein linkes Profil",
      "turnRight": "Zeige jetzt dein rechtes Profil",
      "holdStill": "Halt still…",
      "faceDetected": "Gesicht erkannt ✓",
      "frontCaptured": "✓ Vorderseite aufgenommen",
      "leftCaptured": "✓ Linkes Profil aufgenommen",
      "rightCaptured": "✓ Rechtes Profil aufgenommen",
      "verificationComplete": "Du bist Vibe Verifiziert ✓",
      "uploading": "Deine Fotos werden hochgeladen…",
      "fallbackMessage": "Automatische Überprüfung nicht möglich. Du kannst deine Fotos stattdessen zur manuellen Überprüfung einreichen.",
      "fallbackSubmit": "Zur manuellen Überprüfung einreichen",
      "tryAgain": "Erneut versuchen",
      "errorGeneric": "Überprüfung konnte nicht abgeschlossen werden. Achte darauf, dass dein Gesicht gut sichtbar ist, und versuche es erneut."
    }
  },
  "uploadPlan": {
    "signInBody": "Melden Sie sich an, bevor Sie einen Plan erstellen.",
    "missingDetails": "Fehlende Details",
    "missingDetailsBody": "Fügen Sie einen Plantitel und eine Beschreibung hinzu.",
    "missingLocation": "Fehlender Standort",
    "missingLocationBody": "Fügen Sie den Treffpunkt und die Stadt hinzu.",
    "missingDate": "Fehlendes Datum",
    "missingDateBody": "Wählen Sie das Startdatum und die Startzeit aus.",
    "participantLimit": "Teilnehmerlimit",
    "participantLimitBody": "Das Teilnehmerlimit des Plans muss mindestens 2 betragen.",
    "safetySetup": "Sicherheitseinrichtung",
    "safetySetupBody": "Erkennen Sie die Sicherheitsverantwortung vor der Veröffentlichung an.",
    "invalidDate": "Ungültiges Datum",
    "futureDate": "Bitte wählen Sie heute oder ein zukünftiges Datum aus.",
    "invalidTime": "Ungültige Zeit",
    "pastTime": "Die Startzeit darf nicht in der Vergangenheit liegen.",
    "publishFailed": "Plan konnte nicht veröffentlicht werden",
    "back": "← Zurück",
    "communityPlan": "Gemeinschaftsplan",
    "createPlan": "Plan erstellen",
    "alwaysFree": "Pläne sind immer kostenlos",
    "alwaysFreeBody": "Community-Pläne können keine Zahlungen oder Tickets ermöglichen.",
    "title": "Plantitel",
    "description": "Planbeschreibung",
    "city": "Stadt",
    "cityHelp": "Pläne werden nur innerhalb der ausgewählten Stadt angezeigt.",
    "chooseCity": "Wählen Sie Ihre Stadt",
    "dateRange": "Datumsbereich",
    "dateRangeHelp": "Helfen Sie anderen zu wissen, wann und wo sie sich treffen können.",
    "location": "Standort",
    "locationPlaceholder": "Wo soll man sich treffen?",
    "dateFrom": "Datum von",
    "timeFrom": "Zeit von",
    "safety": "Sicherheitseinrichtung",
    "safetyHelp": "Helfen Sie anderen zu verstehen, welcher Art von Plan sie beitreten.",
    "hostedAt": "Gehostet bei",
    "hostedHelp": "Wählen Sie, ob dieser Plan an einem öffentlichen Ort, einem privaten Ort oder einem unbekannten Standorttyp gehostet wird.",
    "visibility": "Plansichtbarkeit",
    "visibilityHelp": "Wählen Sie aus, wer diesen Plan discover nutzen kann.",
    "maxParticipants": "Maximale Teilnehmerzahl (optional)",
    "unlimited": "Für unbegrenzte Zeit leer lassen",
    "responsibility": "Ich verstehe, dass ich für die Erstellung eines sicheren und respektvollen Plans verantwortlich bin.",
    "publish": "Plan veröffentlichen",
    "publicPlace": "Öffentlicher Ort",
    "privatePlace": "Privater Ort",
    "unknown": "Unbekannt",
    "public": "Öffentlich",
    "friends": "Freunde",
    "inviteOnly": "Nur auf Einladung",
    "startedFromTemplate": "Basierend auf einer Tonyte-Vorlage",
    "endsAt": "Plan endet um",
    "endsAtHelp": "Der Plan verschwindet danach aus Tonyte und wird anschließend automatisch gelöscht.",
    "endDate": "Enddatum",
    "endTime": "Endzeit",
    "missingEnd": "Endzeit fehlt",
    "missingEndBody": "Wähle, wann der Plan endet.",
    "endBeforeStart": "Der Plan muss nach seinem Beginn enden.",
    "endTooLate": "Ein Plan darf höchstens 14 Tage dauern."
  },
  "uploadEvent": {
    "signInBody": "Melden Sie sich an, bevor Sie eine Veranstaltung veröffentlichen.",
    "missingDetails": "Fehlende Details",
    "missingDetailsBody": "Fügen Sie einen Veranstaltungstitel und eine Beschreibung hinzu.",
    "missingDate": "Fehlendes Datum",
    "missingDateBody": "Wählen Sie das Startdatum und die Startzeit aus.",
    "participantLimit": "Teilnehmerlimit",
    "participantLimitBody": "Geben Sie 0 für „unbegrenzt“ oder ein Teilnehmerlimit größer als 0 ein.",
    "invalidDate": "Ungültiges Datum",
    "futureDate": "Bitte wählen Sie heute oder ein zukünftiges Datum aus.",
    "invalidTime": "Ungültige Zeit",
    "startPast": "Die Startzeit darf nicht in der Vergangenheit liegen.",
    "endBeforeStart": "Das Enddatum darf nicht vor dem Startdatum liegen.",
    "endTimeBeforeStart": "Die Endzeit muss nach der Startzeit liegen.",
    "untilBeforeStart": "Das Bis-Datum darf nicht vor dem Startdatum des Ereignisses liegen.",
    "tagRequired": "Ereignis-Tag erforderlich",
    "tagRequiredBody": "Bitte wählen Sie mindestens ein Veranstaltungs-Tag aus, damit die Leute Ihre Veranstaltung discover können.",
    "permissionRequired": "Erlaubnis erforderlich",
    "editPermission": "Nur Administratoren, Co-Administratoren und der Event-Organisator können dieses Event bearbeiten.",
    "addressWarning": "Wir konnten diese genaue Adresse nicht überprüfen, speichern sie jedoch wie eingegeben.",
    "publishFailed": "Ereignis konnte nicht veröffentlicht werden",
    "back": "← Zurück",
    "officialEvent": "Offizielle Veranstaltung",
    "editEvent": "Ereignis bearbeiten",
    "repostEvent": "Repost-Ereignis",
    "fromTemplate": "Neu aus Vorlage",
    "createEvent": "Ereignis erstellen",
    "addCover": "Titelbild hinzufügen",
    "invalidImage": "Ungültiges Eventbild",
    "imageTooLarge": "Wähle ein Bild unter 15 MB.",
    "unsupportedImage": "Wähle ein JPEG-, PNG-, WebP-, HEIC- oder HEIF-Bild.",
    "title": "Veranstaltungstitel",
    "description": "Ereignisbeschreibung",
    "venueOrganizer": "Veranstaltungsort / Veranstalter",
    "lineup": "Aufstellung / Gastgeber (durch Kommas getrennt)",
    "websiteUrl": "Website-URL",
    "instagramUrl": "Instagram-URL",
    "sourceUrl": "URL der Ereignis-/Quellenseite",
    "location": "Standort",
    "locationHelp": "Suchen Sie nach einem Veranstaltungsort oder einer Adresse. Wählen Sie aus den Vorschlägen aus, um Ihre Veranstaltung auf der Karte anzuheften.",
    "city": "Stadt",
    "cityHelp": "Veranstaltungen werden nur innerhalb der ausgewählten Stadt angezeigt.",
    "dateRange": "Datumsbereich",
    "dateRangeHelp": "Legen Sie das Datum und die Uhrzeit der öffentlichen Veranstaltung fest.",
    "dateFrom": "Datum von",
    "dateTo": "Datum bis",
    "timeFrom": "Zeit von",
    "timeTo": "Zeit für",
    "lastEntry": "Letzter Eintragszeitpunkt",
    "lastEntryHelp": "Verstecken Sie dieses Ereignis nach dieser Zeit vor „Fortlaufend“, auch wenn es später endet.",
    "eventTags": "EVENT-TAGS",
    "tagsHelp": "Wählen Sie alles aus, was zutrifft · mindestens eines ist erforderlich",
    "maxParticipants": "Maximale Teilnehmerzahl",
    "maxParticipantsHelp": "Geben Sie 0 für unbegrenzte Teilnehmer ein.",
    "maxParticipantsPlaceholder": "Maximale Teilnehmerzahl",
    "freeEvent": "Kostenlose Veranstaltung",
    "freeEventHelp": "Alle Veranstaltungen sind im aktuellen Tonyte-Build kostenlos.",
    "saveTemplate": "Als Vorlage speichern",
    "saveTemplateHelp": "Speichern Sie diesen vollständigen Veranstaltungsbeitrag für zukünftige Uploads.",
    "saveCurrentTemplate": "Aktuelle Felder als Vorlage speichern",
    "recurring": "Wiederkehrendes Ereignis",
    "recurringHelp": "Verwenden Sie die Vorlagenfelder und erstellen Sie mehrere Ereignisinstanzen.",
    "oneTime": "Einmaliges Ereignis",
    "weekly": "Wöchentlich",
    "custom": "Benutzerdefiniert",
    "repeatEvery": "Wiederholen Sie alle",
    "until": "Bis",
    "occurrences": "Vorkommen",
    "customDates": "Benutzerdefinierte Veranstaltungstermine",
    "customDatesHelp": "Durch Kommas getrennte Daten, z. B. 15.06.2026, 22.06.2026",
    "skipDates": "Termine überspringen",
    "skipDatesHelp": "Durch Kommas getrennte Daten, die übersprungen werden sollen.",
    "saveEvent": "Ereignis speichern",
    "publishRepost": "Repost veröffentlichen",
    "publishEvent": "Ereignis veröffentlichen",
    "selectCity": "Stadt auswählen",
    "locationRequired": "Standort erforderlich",
    "locationRequiredBody": "Bitte suchen Sie nach einem Ort und wählen Sie ihn aus den Vorschlägen aus, damit Ihre Veranstaltung auf der Karte angezeigt werden kann.",
    "ok": "OK",
    "hashtags": "Hashtags",
    "selected": "ausgewählt",
    "addHashtags": "Hashtags hinzufügen",
    "collapseHashtags": "Hashtags ausblenden",
    "hashtagsHelp": "Event-Hashtags suchen oder hinzufügen. Trennen Sie mehrere Hashtags durch Kommas."
  },
  "venueProfiles": {
    "open": "Öffnen",
    "mapUnavailable": "Karte nicht verfügbar",
    "noAddress": "Dieser Veranstaltungsort enthält noch keine Adresse.",
    "mapOpenFailed": "Karte konnte nicht geöffnet werden",
    "followers": "Follower",
    "posts": "Beiträge",
    "events": "Ereignisse",
    "upcoming": "Demnächst",
    "past": "Vergangenheit",
    "about": "Über",
    "calendar": "Kalender",
    "noEventsOnDay": "Keine Events an diesem Tag.",
    "yourVenue": "Dein Profil",
    "editProfile": "Profil bearbeiten",
    "editLoadFailed": "Profil konnte nicht geladen werden",
    "editSaveFailed": "Änderungen konnten nicht gespeichert werden",
    "editNotAllowed": "Nur der Inhaber kann dieses Profil bearbeiten.",
    "coverPhoto": "Titelbild",
    "profilePhoto": "Profilbild",
    "changePhoto": "Ändern",
    "coverHint": "Ziehen zum Verschieben, mit zwei Fingern oder dem Regler zoomen. Genau so erscheint es auf deinem Profil und in Vibe at Venues.",
    "adjustPhoto": "Anpassen",
    "bioLabel": "Bio",
    "bioPlaceholder": "Erzähl, worum es bei deinem Ort geht",
    "categoryLabel": "Kategorie",
    "dashboard": "Analyse-Dashboard",
    "analytics": "Analysen",
    "calendarImports": "Kalender-Importe",
    "unavailable": "Dieses Profil ist nicht verfügbar.",
    "calendarImportsSub": "Importierte Events prüfen und veröffentlichen",
    "dashboardSub": "Taps, Interesse, Shares und Event-Performance",
    "follow": "Folgen",
    "following": "Nachfolgend",
    "organizerNotFound": "Organizer nicht gefunden",
    "organizerUnavailable": "Dieses Organisatorprofil ist noch nicht verfügbar.",
    "vibesTitle": "Vibe an Veranstaltungsorten",
    "vibesSubtitle": "Finden Sie die Orte, an denen sich Ihre Leute versammeln.",
    "search": "Durchsuchen Sie Veranstaltungsorte, Clubs, Cafés, Bars ...",
    "refreshFailed": "Veranstaltungsortbeiträge konnten nicht aktualisiert werden. Zeigen, was verfügbar ist.",
    "noVenues": "Keine Veranstaltungsorte gefunden",
    "noVenuesSub": "Versuchen Sie es mit einer anderen Suche oder Kategorie.",
    "signInFollowVenue": "Melden Sie sich an, bevor Sie Veranstaltungsorten folgen.",
    "signInFollowOrganizer": "Melden Sie sich an, bevor Sie Organisatoren folgen.",
    "signInLike": "Melden Sie sich an, bevor Sie Veranstaltungsortbeiträge mit „Gefällt mir“ markieren.",
    "signInComment": "Melden Sie sich an, bevor Sie Beiträge zum Veranstaltungsort kommentieren.",
    "signInDeleteComment": "Melden Sie sich an, bevor Sie Kommentare löschen.",
    "notAllowed": "Nicht zulässig",
    "ownCommentsOnly": "Sie können nur Ihre eigenen Kommentare löschen."
  },
  "verificationComplete": {
    "noToken": "Kein Verifizierungstoken gefunden. Bitte nutzen Sie den Link aus Ihrer E-Mail.",
    "couldNotComplete": "Die Überprüfung konnte nicht abgeschlossen werden.",
    "expiredBody": "Dieser Link ist abgelaufen. Bitte fordern Sie in der App eine neue Bestätigungs-E-Mail an.",
    "invalidBody": "Dieser Bestätigungslink ist ungültig oder wurde bereits verwendet.",
    "verifying": "Überprüfen…",
    "verified": "E-Mail-Adresse des Studenten bestätigt",
    "underReview": "Wird derzeit überprüft",
    "expired": "Link abgelaufen",
    "invalid": "Ungültiger Link",
    "failed": "Überprüfung fehlgeschlagen",
    "checking": "Überprüfen Sie die E-Mail-Bestätigung Ihres Studenten…",
    "verifiedUniversity": "E-Mail-Adresse des Studenten bestätigt. Willkommen bei StudiZone. Ihr {university}-Studentenstatus wurde bestätigt.",
    "verifiedWelcome": "E-Mail-Adresse des Studenten bestätigt. Willkommen bei StudiZone.",
    "pendingBody": "E-Mail-Inhaber bestätigt. Die Überprüfung Ihrer Studentenverifizierung steht noch aus.",
    "back": "Zurück zu Tonyte"
  },
  "permissions": {
    "locationTitle": "Ihren Standort verwenden?",
    "locationMessage": "Tonyte verwendet Ihren Standort, um Ereignisse und Pläne in der Nähe anzuzeigen.",
    "notificationsTitle": "Benachrichtigungen aktivieren?",
    "notificationsMessage": "Tonyte verwendet Benachrichtigungen für neue Nachrichten, Planaktualisierungen und Ereigniserinnerungen.",
    "cameraTitle": "Benutzen Sie Ihre Kamera?",
    "cameraMessage": "Tonyte verwendet Ihre Kamera, wenn Sie Fotos für Ihr Profil, Veranstaltungen, Pläne oder zur Gesichtsüberprüfung aufnehmen möchten.",
    "microphoneTitle": "Benutzen Sie Ihr Mikrofon?",
    "microphoneMessage": "Tonyte benötigt Mikrofonzugriff, um Sprachnotizen zu senden.",
    "locationLabel": "Standort",
    "notificationsLabel": "Benachrichtigungen",
    "cameraLabel": "Kamera",
    "microphoneLabel": "Mikrofon",
    "disabled": "Berechtigung deaktiviert",
    "notGranted": "Erlaubnis nicht erteilt",
    "blockedBody": "Tonyte hat keinen Zugriff auf Ihren {permission}. Sie können es in den Einstellungen aktivieren.",
    "deniedBody": "Sie können ohne {permission}-Zugriff fortfahren. Einige Funktionen können eingeschränkt sein."
  },
  "notifications": {
    "newJoinRequest": "Neue Beitrittsanfrage",
    "newJoinRequestBody": "Sie haben eine neue Beitrittsanfrage.",
    "planAccepted": "Du bist dabei 🎉",
    "planAcceptedBody": "Du wurdest in einen Plan aufgenommen.",
    "newVibeRequest": "Neue Vibe-Anfrage ✨",
    "newVibeRequestBody": "Jemand möchte mit dir viben.",
    "vibeAccepted": "Es ist ein Vibe ✨",
    "vibeAcceptedBody": "Deine Vibe-Anfrage wurde angenommen.",
    "eventsTitle": "Was in Dresden los ist",
    "eventsBody": "Neue Events warten auf dich.",
    "vibePlanTitle": "Einer deiner Vibes hat einen Plan erstellt",
    "vibePlanBody": "Tippe, um den Plan zu sehen und mitzumachen.",
    "partnerUpdateTitle": "Neues von einem Partner, dem du folgst",
    "partnerUpdateBody": "Schau dir an, was neu ist.",
    "newFollowerTitle": "Du hast einen neuen Follower 🧡",
    "newFollowerBody": "Jemand folgt dir jetzt auf Tonyte.",
    "profilePhotoReminderTitle": "Vervollständige dein Tonyte-Profil 👋",
    "profilePhotoReminderBody": "Füge ein Profilbild hinzu, um Pläne und Vibes freizuschalten.",
    "appUpdateReminderTitle": "Ein besseres Tonyte wartet 🧡",
    "appUpdateReminderBody": "Aktualisiere Tonyte für die neuesten Funktionen, Fehlerbehebungen und Verbesserungen."
  },
  "vibeClaim": {
    "playedOnWeb": "Das Vibe-Spiel im Web gespielt?",
    "enterCodeTitle": "Web-Antworten hinzufügen",
    "enterCodeBody": "Gib den Code vom Ende des Vibe-Spiels auf tonyte.app ein.",
    "continue": "Weiter",
    "ok": "OK",
    "invalidFormat": "Codes sehen so aus: ABCD-EFGH.",
    "invalidCode": "Diesen Code gibt es nicht oder er ist abgelaufen.",
    "oldRoundCode": "Dieser Code war für eine frühere Runde, die bereits beendet ist.",
    "alreadyClaimedCode": "Diese Antworten wurden bereits einem Tonyte-Konto hinzugefügt.",
    "savedSignIn": "Alles klar! Melde dich an oder erstelle ein Konto, dann fügen wir deine Antworten hinzu.",
    "networkError": "Der Code konnte nicht geprüft werden. Prüfe deine Verbindung und versuche es erneut.",
    "rateLimited": "Zu viele Versuche. Bitte warte ein paar Minuten.",
    "waitingBanner": "Deine Vibe-Antworten aus dem Web warten. Melde dich an oder registriere dich, um deine Vibes zu sehen.",
    "discard": "Web-Antworten verwerfen",
    "addedToast": "Deine Web-Antworten sind drin ✨",
    "unlocksAt13": "Deine ersten Vibes werden um 13:00 Uhr freigeschaltet.",
    "alreadyPlayedTodayTitle": "Du hast das heutige Vibe-Spiel gespielt",
    "alreadyPlayedTodayBody": "Deine Antworten für heute sind schon drin. Jedes Konto spielt einmal pro Tag, daher kann kein Web-Code mehr hinzugefügt werden. Die nächste Runde startet morgen um 6:00 Uhr.",
    "addingTitle": "Deine Web-Antworten werden hinzugefügt…",
    "addingBody": "Wir fügen die Antworten aus deinem Code hinzu. Das dauert nur einen Moment.",
    "notOpenTitle": "Das heutige Spiel ist noch nicht geöffnet",
    "notOpenBody": "Das Vibe-Spiel öffnet um 6:00 Uhr. Codes gelten nur an dem Tag, an dem du gespielt hast.",
    "seeMyVibes": "Meine Vibes ansehen",
    "alreadyPlayedTitle": "Du hast heute schon gespielt",
    "alreadyPlayedBody": "Du hattest die heutigen Vibe-Fragen schon in der App beantwortet, deshalb bleiben diese Antworten. Antworten sind danach fest, deine Web-Antworten wurden nicht verwendet.",
    "roundClosedTitle": "Diese Antworten waren für {date}",
    "roundClosedBody": "Web-Antworten zählen nur in der Runde, in der sie gespielt wurden, und diese Runde ist beendet. Die heutigen Fragen warten in Day Vibes.",
    "playToday": "Heute spielen",
    "claimedElsewhereTitle": "Schon in einem anderen Konto",
    "claimedElsewhereBody": "Diese Antworten wurden einem anderen Tonyte-Konto hinzugefügt. Jede Antwortrunde kann nur zu einem Konto gehören.",
    "notFoundTitle": "Antworten konnten nicht hinzugefügt werden",
    "notFoundBody": "Der Link oder Code ist abgelaufen oder ungültig. Web-Antworten können bis Mitternacht (Berliner Zeit) am Spieltag hinzugefügt werden.",
    "notEligibleBody": "Day Vibes ist für diesen Kontotyp nicht verfügbar.",
    "emailFoundTitle": "Web-Antworten hinzufügen?",
    "emailFoundBody": "Du hast die heutigen Vibe-Antworten auf tonyte.app mit {email} gespeichert. Zu diesem Konto hinzufügen?",
    "addAnswers": "Hinzufügen",
    "notNow": "Nicht jetzt"
  },
  partnerCommunity: {
    button: 'Community chat',
    followToJoinTitle: 'Follow to join?',
    followToJoinBody: 'Follow {name} to join their community chat.',
    followAndJoin: 'Follow & join',
    signIn: 'Sign in to join this partner’s community. You’ll return here afterward.',
    signInAction: 'Sign in',
    joinFailed: 'Couldn’t join the community. Please try again.',
    unfollowTitle: 'Unfollow and leave community?',
    unfollowBody: 'Unfollowing {name} also removes you from their community chat.',
    unfollowAndLeave: 'Unfollow & leave',
    messagesTab: 'Messages',
    notificationsTab: 'Notifications',
    communitiesTab: 'Community Chats',
    incoming: 'Incoming requests',
    outgoing: 'Outgoing requests',
    emptyTitle: 'Find your communities',
    emptyBody: 'Follow a partner and join their community to chat with people around it.',
    discover: 'Discover partners',
    about: 'The official member chat for this partner.',
    memberOnly: 'Followers’ community',
    leaveConfirm: 'Leave this community chat? You will keep following the partner.',
    ownerCannotLeave: 'You administer this community as the partner owner.',
    accessRemoved: 'You no longer have access to this community.',
    allowBack: 'Allow back',
    allowedBack: 'This person can rejoin after following the partner.',
    rejoined: 'Member reinstated.',
    descriptionPlaceholder: 'Community-Beschreibung hinzufügen…',
    descriptionSaved: 'Community-Beschreibung aktualisiert.',
    descriptionSaveFailed: 'Die Beschreibung konnte nicht aktualisiert werden.',
    admin: 'Admin',
    coAdmin: 'Co-Admin',
    makeCoAdmin: 'Zum Co-Admin machen',
    removeCoAdmin: 'Co-Admin-Rolle entfernen',
    coAdminAdded: '{name} ist jetzt Co-Admin.',
    coAdminRemoved: '{name} ist nicht mehr Co-Admin.',
  },
  "partnerReviews": {
    "tab": "Bewertungen",
    "reviewCount_one": "{count} Bewertung",
    "reviewCount_other": "{count} Bewertungen",
    "ratingCount_one": "{count} Bewertung",
    "ratingCount_other": "{count} Bewertungen",
    "starCount_one": "{count} Stern",
    "starCount_other": "{count} Sterne",
    "noReviewsYet": "Noch keine Bewertungen",
    "beFirst": "Schreib die erste",
    "summaryA11y": "Bewertet mit {avg} von 5 aus {count} Bewertungen. Bewertungen anzeigen",
    "write": "Bewertung schreiben",
    "edit": "Deine Bewertung bearbeiten",
    "ownProfile": "Bewertungen kommen von Besucher*innen – dein eigenes Profil kannst du nicht bewerten.",
    "signInToReview": "Melde dich an oder registriere dich, um eine Bewertung zu schreiben.",
    "filterAll": "Alle",
    "empty": "Noch keine Bewertungen",
    "emptySub": "Schon da gewesen? Erzähl, wie es war, und hilf anderen bei der Entscheidung.",
    "emptyFiltered": "Noch keine {count}-Sterne-Bewertungen.",
    "loadFailed": "Bewertungen konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "showMore": "Weitere Bewertungen anzeigen",
    "edited": "Bearbeitet",
    "readMore": "Mehr lesen",
    "showLess": "Weniger anzeigen",
    "yourReview": "Deine Bewertung",
    "hiddenNotice": "Nur du siehst diese Bewertung, während unser Team sie prüft.",
    "removedNotice": "Unser Moderationsteam hat diese Bewertung entfernt. Du kannst sie löschen und eine neue schreiben.",
    "menu": "Optionen für die Bewertung",
    "titleNew": "{name} bewerten",
    "titleEdit": "Deine Bewertung bearbeiten",
    "aboutPartner": "Du bewertest {name} insgesamt, nicht ein einzelnes Event.",
    "draftRestored": "Wir haben deine unfertige Bewertung aufbewahrt.",
    "ratingLabel": "Deine Bewertung",
    "tapToRate": "Tippe auf einen Stern",
    "ratingRequired": "Wähle eine Sternebewertung, um fortzufahren.",
    "textLabel": "Deine Bewertung (optional)",
    "placeholder": "Wie war es? Atmosphäre, Leute, Events …",
    "submit": "Bewertung posten",
    "update": "Änderungen speichern",
    "posted": "Danke für deine Bewertung!",
    "updated": "Bewertung aktualisiert",
    "deleted": "Bewertung gelöscht",
    "deleteTitle": "Bewertung löschen?",
    "deleteBody": "Deine Sterne und dein Text werden von {name} entfernt.",
    "ratingWords": {
      "1": "Nicht meins",
      "2": "Geht besser",
      "3": "Okay",
      "4": "Richtig gut",
      "5": "Geliebt"
    },
    "actions": {
      "edit": "Bewertung bearbeiten",
      "delete": "Bewertung löschen",
      "report": "Bewertung melden",
      "hide": "Bewertung ausblenden (Admin)",
      "restore": "Bewertung wiederherstellen (Admin)",
      "remove": "Bewertung entfernen (Admin)",
      "dismiss": "Meldungen schließen"
    },
    "confirm": {
      "hideTitle": "Bewertung ausblenden?",
      "hideBody": "Sie verschwindet vom Profil und zählt nicht mehr zur Gesamtbewertung, bis sie wiederhergestellt wird.",
      "removeTitle": "Bewertung entfernen?",
      "removeBody": "Der Text wird gelöscht und sie zählt nicht mehr zur Gesamtbewertung. Das kann nicht rückgängig gemacht werden.",
      "dismissTitle": "Meldungen schließen?",
      "dismissBody": "Die Bewertung bleibt sichtbar und die Meldungen werden geschlossen."
    },
    "moderated": {
      "hide": "Bewertung ausgeblendet",
      "restore": "Bewertung wiederhergestellt",
      "remove": "Bewertung entfernt",
      "dismiss": "Meldungen geschlossen"
    },
    "reportTitle": "Bewertung melden",
    "reportReason": "Warum meldest du sie?",
    "reasons": {
      "spam": "Spam oder Werbung",
      "harassment": "Belästigung oder Hass",
      "inappropriate": "Unangemessener Inhalt",
      "fake": "Gefälscht oder irreführend",
      "other": "Etwas anderes"
    },
    "reportDetails": "Möchtest du noch etwas ergänzen? (optional)",
    "reportSubmit": "Meldung senden",
    "reported": "Danke – unser Team schaut sich das an.",
    "errors": {
      "signIn": "Bitte melde dich erneut an, um deine Bewertung zu posten. Dein Entwurf ist gespeichert.",
      "verifyEmail": "Bestätige deine E-Mail, um Bewertungen zu posten. Dein Entwurf ist gespeichert.",
      "ownProfile": "Du kannst dein eigenes Profil nicht bewerten.",
      "removed": "Diese Bewertung wurde vom Moderationsteam entfernt und kann nicht bearbeitet werden.",
      "rating": "Wähle eine Bewertung von 1 bis 5 Sternen.",
      "tooLong": "Bewertungen dürfen höchstens 1.000 Zeichen lang sein.",
      "unavailable": "Dieses Profil ist nicht verfügbar.",
      "reviewGone": "Diese Bewertung ist nicht mehr verfügbar.",
      "ownReview": "Du kannst deine eigene Bewertung nicht melden.",
      "access": "Dein Konto kann gerade keine Bewertungen posten.",
      "network": "Verbindungsproblem – bitte versuch es noch einmal. Dein Entwurf ist gespeichert.",
      "generic": "Etwas ist schiefgelaufen. Bitte versuch es noch einmal."
    },
    "admin": {
      "title": "Gemeldete Bewertungen",
      "profileSub": "Gemeldete Partner-Bewertungen ausblenden oder entfernen",
      "open": "Offen",
      "resolved": "Erledigt",
      "empty": "Keine gemeldeten Bewertungen.",
      "reason": "Grund",
      "details": "Details",
      "reportedAt": "Gemeldet am {date}",
      "currentStatus": "Jetzt",
      "status": {
        "published": "Sichtbar",
        "hidden": "Ausgeblendet",
        "removed": "Entfernt",
        "missing": "Gelöscht"
      },
      "resolution": {
        "hidden": "Ausgeblendet",
        "removed": "Entfernt",
        "dismissed": "Geschlossen",
        "review_deleted": "Von der Person gelöscht",
        "restored": "Wiederhergestellt"
      },
      "openProfile": "Profil öffnen",
      "loadFailed": "Meldungen konnten nicht geladen werden."
    }
  }
};
